(function() {
  function e(a) {
    return function(d, c, f, q) {
      c = j(c, q, 4);
      var e = !C(d) && g.keys(d),
        h = (e || d).length,
        l = 0 < a ? 0 : h - 1;
      3 > arguments.length && ((f = d[e ? e[l] : l]), (l += a));
      for (var s = c, t = f; 0 <= l && l < h; l += a) var B = e ? e[l] : l, t = s(t, d[B], B, d);
      return t;
    };
  }
  function h(a) {
    return function(d, g, c) {
      g = x(g, c);
      c = A(d);
      for (var f = 0 < a ? 0 : c - 1; 0 <= f && f < c; f += a) if (g(d[f], f, d)) return f;
      return -1;
    };
  }
  function p(a, d, c) {
    return function(q, e, j) {
      var h = 0,
        l = A(q);
      if ('number' == typeof j)
        0 < a ? (h = 0 <= j ? j : Math.max(j + l, h)) : (l = 0 <= j ? Math.min(j + 1, l) : j + l + 1);
      else if (c && j && l) return (j = c(q, e)), q[j] === e ? j : -1;
      if (e !== e) return (j = d(f.call(q, h, l), g.isNaN)), 0 <= j ? j + h : -1;
      for (j = 0 < a ? h : l - 1; 0 <= j && j < l; j += a) if (q[j] === e) return j;
      return -1;
    };
  }
  function n(d, c) {
    var f = K.length,
      q = d.constructor,
      q = (g.isFunction(q) && q.prototype) || a,
      j = 'constructor';
    for (g.has(d, j) && !g.contains(c, j) && c.push(j); f--; )
      (j = K[f]), j in d && (d[j] !== q[j] && !g.contains(c, j)) && c.push(j);
  }
  var r = this,
    k = r._,
    m = Array.prototype,
    a = Object.prototype,
    c = m.push,
    f = m.slice,
    l = a.toString,
    d = a.hasOwnProperty,
    t = Array.isArray,
    s = Object.keys,
    D = Function.prototype.bind,
    y = Object.create,
    u = function() {},
    g = function(a) {
      if (a instanceof g) return a;
      if (!(this instanceof g)) return new g(a);
      this._wrapped = a;
    };
  'undefined' !== typeof exports
    ? ('undefined' !== typeof module && module.exports && (exports = module.exports = g), (exports._ = g))
    : (r._ = g);
  g.VERSION = '1.8.3';
  var j = function(a, d, c) {
      if (void 0 === d) return a;
      switch (null == c ? 3 : c) {
        case 1:
          return function(c) {
            return a.call(d, c);
          };
        case 2:
          return function(c, g) {
            return a.call(d, c, g);
          };
        case 3:
          return function(c, g, f) {
            return a.call(d, c, g, f);
          };
        case 4:
          return function(c, g, f, j) {
            return a.call(d, c, g, f, j);
          };
      }
      return function() {
        return a.apply(d, arguments);
      };
    },
    x = function(a, d, c) {
      return null == a ? g.identity : g.isFunction(a) ? j(a, d, c) : g.isObject(a) ? g.matcher(a) : g.property(a);
    };
  g.iteratee = function(a, d) {
    return x(a, d, Infinity);
  };
  var w = function(a, d) {
      return function(c) {
        var g = arguments.length;
        if (2 > g || null == c) return c;
        for (var f = 1; f < g; f++)
          for (var j = arguments[f], q = a(j), e = q.length, l = 0; l < e; l++) {
            var h = q[l];
            if (!d || void 0 === c[h]) c[h] = j[h];
          }
        return c;
      };
    },
    v = function(a) {
      if (!g.isObject(a)) return {};
      if (y) return y(a);
      u.prototype = a;
      a = new u();
      u.prototype = null;
      return a;
    },
    z = function(a) {
      return function(d) {
        return null == d ? void 0 : d[a];
      };
    },
    E = Math.pow(2, 53) - 1,
    A = z('length'),
    C = function(a) {
      a = A(a);
      return 'number' == typeof a && 0 <= a && a <= E;
    };
  g.each = g.forEach = function(a, d, c) {
    d = j(d, c);
    var f;
    if (C(a)) {
      c = 0;
      for (f = a.length; c < f; c++) d(a[c], c, a);
    } else {
      var q = g.keys(a);
      c = 0;
      for (f = q.length; c < f; c++) d(a[q[c]], q[c], a);
    }
    return a;
  };
  g.map = g.collect = function(a, d, c) {
    d = x(d, c);
    c = !C(a) && g.keys(a);
    for (var f = (c || a).length, j = Array(f), q = 0; q < f; q++) {
      var e = c ? c[q] : q;
      j[q] = d(a[e], e, a);
    }
    return j;
  };
  g.reduce = g.foldl = g.inject = e(1);
  g.reduceRight = g.foldr = e(-1);
  g.find = g.detect = function(a, d, c) {
    d = C(a) ? g.findIndex(a, d, c) : g.findKey(a, d, c);
    if (void 0 !== d && -1 !== d) return a[d];
  };
  g.filter = g.select = function(a, d, c) {
    var f = [];
    d = x(d, c);
    g.each(a, function(a, c, g) {
      d(a, c, g) && f.push(a);
    });
    return f;
  };
  g.reject = function(a, d, c) {
    return g.filter(a, g.negate(x(d)), c);
  };
  g.every = g.all = function(a, d, c) {
    d = x(d, c);
    c = !C(a) && g.keys(a);
    for (var f = (c || a).length, q = 0; q < f; q++) {
      var j = c ? c[q] : q;
      if (!d(a[j], j, a)) return !1;
    }
    return !0;
  };
  g.some = g.any = function(a, d, c) {
    d = x(d, c);
    c = !C(a) && g.keys(a);
    for (var f = (c || a).length, q = 0; q < f; q++) {
      var j = c ? c[q] : q;
      if (d(a[j], j, a)) return !0;
    }
    return !1;
  };
  g.contains = g.includes = g.include = function(a, d, c, f) {
    C(a) || (a = g.values(a));
    if ('number' != typeof c || f) c = 0;
    return 0 <= g.indexOf(a, d, c);
  };
  g.invoke = function(a, d) {
    var c = f.call(arguments, 2),
      q = g.isFunction(d);
    return g.map(a, function(a) {
      var g = q ? d : a[d];
      return null == g ? g : g.apply(a, c);
    });
  };
  g.pluck = function(a, d) {
    return g.map(a, g.property(d));
  };
  g.where = function(a, d) {
    return g.filter(a, g.matcher(d));
  };
  g.findWhere = function(a, d) {
    return g.find(a, g.matcher(d));
  };
  g.max = function(a, d, c) {
    var f = -Infinity,
      q = -Infinity,
      j;
    if (null == d && null != a) {
      a = C(a) ? a : g.values(a);
      for (var e = 0, l = a.length; e < l; e++) (c = a[e]), c > f && (f = c);
    } else
      (d = x(d, c)),
        g.each(a, function(a, c, g) {
          j = d(a, c, g);
          if (j > q || (-Infinity === j && -Infinity === f)) (f = a), (q = j);
        });
    return f;
  };
  g.min = function(a, d, c) {
    var f = Infinity,
      q = Infinity,
      j;
    if (null == d && null != a) {
      a = C(a) ? a : g.values(a);
      for (var e = 0, l = a.length; e < l; e++) (c = a[e]), c < f && (f = c);
    } else
      (d = x(d, c)),
        g.each(a, function(a, c, g) {
          j = d(a, c, g);
          if (j < q || (Infinity === j && Infinity === f)) (f = a), (q = j);
        });
    return f;
  };
  g.shuffle = function(a) {
    a = C(a) ? a : g.values(a);
    for (var d = a.length, c = Array(d), f = 0, q; f < d; f++)
      (q = g.random(0, f)), q !== f && (c[f] = c[q]), (c[q] = a[f]);
    return c;
  };
  g.sample = function(a, d, c) {
    return null == d || c
      ? (C(a) || (a = g.values(a)), a[g.random(a.length - 1)])
      : g.shuffle(a).slice(0, Math.max(0, d));
  };
  g.sortBy = function(a, d, c) {
    d = x(d, c);
    return g.pluck(
      g
        .map(a, function(a, c, f) {
          return { value: a, index: c, criteria: d(a, c, f) };
        })
        .sort(function(a, d) {
          var c = a.criteria,
            f = d.criteria;
          if (c !== f) {
            if (c > f || void 0 === c) return 1;
            if (c < f || void 0 === f) return -1;
          }
          return a.index - d.index;
        }),
      'value',
    );
  };
  var F = function(a) {
    return function(d, c, f) {
      var q = {};
      c = x(c, f);
      g.each(d, function(f, g) {
        var j = c(f, g, d);
        a(q, f, j);
      });
      return q;
    };
  };
  g.groupBy = F(function(a, d, c) {
    g.has(a, c) ? a[c].push(d) : (a[c] = [d]);
  });
  g.indexBy = F(function(a, d, c) {
    a[c] = d;
  });
  g.countBy = F(function(a, d, c) {
    g.has(a, c) ? a[c]++ : (a[c] = 1);
  });
  g.toArray = function(a) {
    return !a ? [] : g.isArray(a) ? f.call(a) : C(a) ? g.map(a, g.identity) : g.values(a);
  };
  g.size = function(a) {
    return null == a ? 0 : C(a) ? a.length : g.keys(a).length;
  };
  g.partition = function(a, d, c) {
    d = x(d, c);
    var f = [],
      q = [];
    g.each(a, function(a, c, g) {
      (d(a, c, g) ? f : q).push(a);
    });
    return [f, q];
  };
  g.first = g.head = g.take = function(a, d, c) {
    return null == a ? void 0 : null == d || c ? a[0] : g.initial(a, a.length - d);
  };
  g.initial = function(a, d, c) {
    return f.call(a, 0, Math.max(0, a.length - (null == d || c ? 1 : d)));
  };
  g.last = function(a, d, c) {
    return null == a ? void 0 : null == d || c ? a[a.length - 1] : g.rest(a, Math.max(0, a.length - d));
  };
  g.rest = g.tail = g.drop = function(a, d, c) {
    return f.call(a, null == d || c ? 1 : d);
  };
  g.compact = function(a) {
    return g.filter(a, g.identity);
  };
  var G = function(a, d, c, f) {
    var q = [],
      j = 0;
    f = f || 0;
    for (var e = A(a); f < e; f++) {
      var l = a[f];
      if (C(l) && (g.isArray(l) || g.isArguments(l))) {
        d || (l = G(l, d, c));
        var h = 0,
          s = l.length;
        for (q.length += s; h < s; ) q[j++] = l[h++];
      } else c || (q[j++] = l);
    }
    return q;
  };
  g.flatten = function(a, d) {
    return G(a, d, !1);
  };
  g.without = function(a) {
    return g.difference(a, f.call(arguments, 1));
  };
  g.uniq = g.unique = function(a, d, c, f) {
    g.isBoolean(d) || ((f = c), (c = d), (d = !1));
    null != c && (c = x(c, f));
    f = [];
    for (var q = [], j = 0, e = A(a); j < e; j++) {
      var l = a[j],
        h = c ? c(l, j, a) : l;
      d
        ? ((!j || q !== h) && f.push(l), (q = h))
        : c
        ? g.contains(q, h) || (q.push(h), f.push(l))
        : g.contains(f, l) || f.push(l);
    }
    return f;
  };
  g.union = function() {
    return g.uniq(G(arguments, !0, !0));
  };
  g.intersection = function(a) {
    for (var d = [], c = arguments.length, f = 0, q = A(a); f < q; f++) {
      var j = a[f];
      if (!g.contains(d, j)) {
        for (var e = 1; e < c && g.contains(arguments[e], j); e++);
        e === c && d.push(j);
      }
    }
    return d;
  };
  g.difference = function(a) {
    var d = G(arguments, !0, !0, 1);
    return g.filter(a, function(a) {
      return !g.contains(d, a);
    });
  };
  g.zip = function() {
    return g.unzip(arguments);
  };
  g.unzip = function(a) {
    for (var d = (a && g.max(a, A).length) || 0, c = Array(d), f = 0; f < d; f++) c[f] = g.pluck(a, f);
    return c;
  };
  g.object = function(a, d) {
    for (var c = {}, f = 0, g = A(a); f < g; f++) d ? (c[a[f]] = d[f]) : (c[a[f][0]] = a[f][1]);
    return c;
  };
  g.findIndex = h(1);
  g.findLastIndex = h(-1);
  g.sortedIndex = function(a, d, c, f) {
    c = x(c, f, 1);
    d = c(d);
    f = 0;
    for (var g = A(a); f < g; ) {
      var q = Math.floor((f + g) / 2);
      c(a[q]) < d ? (f = q + 1) : (g = q);
    }
    return f;
  };
  g.indexOf = p(1, g.findIndex, g.sortedIndex);
  g.lastIndexOf = p(-1, g.findLastIndex);
  g.range = function(a, d, c) {
    null == d && ((d = a || 0), (a = 0));
    c = c || 1;
    d = Math.max(Math.ceil((d - a) / c), 0);
    for (var f = Array(d), g = 0; g < d; g++, a += c) f[g] = a;
    return f;
  };
  var q = function(a, d, c, f, q) {
    if (!(f instanceof d)) return a.apply(c, q);
    d = v(a.prototype);
    a = a.apply(d, q);
    return g.isObject(a) ? a : d;
  };
  g.bind = function(a, d) {
    if (D && a.bind === D) return D.apply(a, f.call(arguments, 1));
    if (!g.isFunction(a)) throw new TypeError('Bind must be called on a function');
    var c = f.call(arguments, 2),
      j = function() {
        return q(a, j, d, this, c.concat(f.call(arguments)));
      };
    return j;
  };
  g.partial = function(a) {
    var d = f.call(arguments, 1),
      c = function() {
        for (var f = 0, j = d.length, e = Array(j), l = 0; l < j; l++) e[l] = d[l] === g ? arguments[f++] : d[l];
        for (; f < arguments.length; ) e.push(arguments[f++]);
        return q(a, c, this, this, e);
      };
    return c;
  };
  g.bindAll = function(a) {
    var d,
      c = arguments.length,
      f;
    if (1 >= c) throw Error('bindAll must be passed function names');
    for (d = 1; d < c; d++) (f = arguments[d]), (a[f] = g.bind(a[f], a));
    return a;
  };
  g.memoize = function(a, d) {
    var c = function(f) {
      var q = c.cache,
        j = '' + (d ? d.apply(this, arguments) : f);
      g.has(q, j) || (q[j] = a.apply(this, arguments));
      return q[j];
    };
    c.cache = {};
    return c;
  };
  g.delay = function(a, d) {
    var c = f.call(arguments, 2);
    return setTimeout(function() {
      return a.apply(null, c);
    }, d);
  };
  g.defer = g.partial(g.delay, g, 1);
  g.throttle = function(a, d, c) {
    var f,
      q,
      j,
      e = null,
      l = 0;
    c || (c = {});
    var h = function() {
      l = !1 === c.leading ? 0 : g.now();
      e = null;
      j = a.apply(f, q);
      e || (f = q = null);
    };
    return function() {
      var s = g.now();
      !l && !1 === c.leading && (l = s);
      var t = d - (s - l);
      f = this;
      q = arguments;
      0 >= t || t > d
        ? (e && (clearTimeout(e), (e = null)), (l = s), (j = a.apply(f, q)), e || (f = q = null))
        : !e && !1 !== c.trailing && (e = setTimeout(h, t));
      return j;
    };
  };
  g.debounce = function(a, d, c) {
    var f,
      q,
      j,
      e,
      l,
      h = function() {
        var s = g.now() - e;
        s < d && 0 <= s ? (f = setTimeout(h, d - s)) : ((f = null), c || ((l = a.apply(j, q)), f || (j = q = null)));
      };
    return function() {
      j = this;
      q = arguments;
      e = g.now();
      var s = c && !f;
      f || (f = setTimeout(h, d));
      s && ((l = a.apply(j, q)), (j = q = null));
      return l;
    };
  };
  g.wrap = function(a, d) {
    return g.partial(d, a);
  };
  g.negate = function(a) {
    return function() {
      return !a.apply(this, arguments);
    };
  };
  g.compose = function() {
    var a = arguments,
      d = a.length - 1;
    return function() {
      for (var c = d, f = a[d].apply(this, arguments); c--; ) f = a[c].call(this, f);
      return f;
    };
  };
  g.after = function(a, d) {
    return function() {
      if (1 > --a) return d.apply(this, arguments);
    };
  };
  g.before = function(a, d) {
    var c;
    return function() {
      0 < --a && (c = d.apply(this, arguments));
      1 >= a && (d = null);
      return c;
    };
  };
  g.once = g.partial(g.before, 2);
  var B = !{ toString: null }.propertyIsEnumerable('toString'),
    K = 'valueOf isPrototypeOf toString propertyIsEnumerable hasOwnProperty toLocaleString'.split(' ');
  g.keys = function(a) {
    if (!g.isObject(a)) return [];
    if (s) return s(a);
    var d = [],
      c;
    for (c in a) g.has(a, c) && d.push(c);
    B && n(a, d);
    return d;
  };
  g.allKeys = function(a) {
    if (!g.isObject(a)) return [];
    var d = [],
      c;
    for (c in a) d.push(c);
    B && n(a, d);
    return d;
  };
  g.values = function(a) {
    for (var d = g.keys(a), c = d.length, f = Array(c), q = 0; q < c; q++) f[q] = a[d[q]];
    return f;
  };
  g.mapObject = function(a, d, c) {
    d = x(d, c);
    c = g.keys(a);
    for (var f = c.length, q = {}, j, e = 0; e < f; e++) (j = c[e]), (q[j] = d(a[j], j, a));
    return q;
  };
  g.pairs = function(a) {
    for (var d = g.keys(a), c = d.length, f = Array(c), q = 0; q < c; q++) f[q] = [d[q], a[d[q]]];
    return f;
  };
  g.invert = function(a) {
    for (var d = {}, c = g.keys(a), f = 0, q = c.length; f < q; f++) d[a[c[f]]] = c[f];
    return d;
  };
  g.functions = g.methods = function(a) {
    var d = [],
      c;
    for (c in a) g.isFunction(a[c]) && d.push(c);
    return d.sort();
  };
  g.extend = w(g.allKeys);
  g.extendOwn = g.assign = w(g.keys);
  g.findKey = function(a, d, c) {
    d = x(d, c);
    c = g.keys(a);
    for (var f, q = 0, j = c.length; q < j; q++) if (((f = c[q]), d(a[f], f, a))) return f;
  };
  g.pick = function(a, d, c) {
    var f = {},
      q = a,
      e,
      l;
    if (null == q) return f;
    g.isFunction(d)
      ? ((l = g.allKeys(q)), (e = j(d, c)))
      : ((l = G(arguments, !1, !1, 1)),
        (e = function(a, d, c) {
          return d in c;
        }),
        (q = Object(q)));
    for (var h = 0, s = l.length; h < s; h++) {
      var t = l[h],
        B = q[t];
      e(B, t, q) && (f[t] = B);
    }
    return f;
  };
  g.omit = function(a, d, c) {
    if (g.isFunction(d)) d = g.negate(d);
    else {
      var f = g.map(G(arguments, !1, !1, 1), String);
      d = function(a, d) {
        return !g.contains(f, d);
      };
    }
    return g.pick(a, d, c);
  };
  g.defaults = w(g.allKeys, !0);
  g.create = function(a, d) {
    var c = v(a);
    d && g.extendOwn(c, d);
    return c;
  };
  g.clone = function(a) {
    return !g.isObject(a) ? a : g.isArray(a) ? a.slice() : g.extend({}, a);
  };
  g.tap = function(a, d) {
    d(a);
    return a;
  };
  g.isMatch = function(a, d) {
    var c = g.keys(d),
      f = c.length;
    if (null == a) return !f;
    for (var q = Object(a), j = 0; j < f; j++) {
      var e = c[j];
      if (d[e] !== q[e] || !(e in q)) return !1;
    }
    return !0;
  };
  var I = function(a, d, c, f) {
    if (a === d) return 0 !== a || 1 / a === 1 / d;
    if (null == a || null == d) return a === d;
    a instanceof g && (a = a._wrapped);
    d instanceof g && (d = d._wrapped);
    var q = l.call(a);
    if (q !== l.call(d)) return !1;
    switch (q) {
      case '[object RegExp]':
      case '[object String]':
        return '' + a === '' + d;
      case '[object Number]':
        return +a !== +a ? +d !== +d : 0 === +a ? 1 / +a === 1 / d : +a === +d;
      case '[object Date]':
      case '[object Boolean]':
        return +a === +d;
    }
    q = '[object Array]' === q;
    if (!q) {
      if ('object' != typeof a || 'object' != typeof d) return !1;
      var j = a.constructor,
        e = d.constructor;
      if (
        j !== e &&
        (!g.isFunction(j) || !(j instanceof j && g.isFunction(e) && e instanceof e)) &&
        'constructor' in a &&
        'constructor' in d
      )
        return !1;
    }
    c = c || [];
    f = f || [];
    for (j = c.length; j--; ) if (c[j] === a) return f[j] === d;
    c.push(a);
    f.push(d);
    if (q) {
      j = a.length;
      if (j !== d.length) return !1;
      for (; j--; ) if (!I(a[j], d[j], c, f)) return !1;
    } else {
      q = g.keys(a);
      j = q.length;
      if (g.keys(d).length !== j) return !1;
      for (; j--; ) if (((e = q[j]), !g.has(d, e) || !I(a[e], d[e], c, f))) return !1;
    }
    c.pop();
    f.pop();
    return !0;
  };
  g.isEqual = function(a, d) {
    return I(a, d);
  };
  g.isEmpty = function(a) {
    return null == a
      ? !0
      : C(a) && (g.isArray(a) || g.isString(a) || g.isArguments(a))
      ? 0 === a.length
      : 0 === g.keys(a).length;
  };
  g.isElement = function(a) {
    return !!(a && 1 === a.nodeType);
  };
  g.isArray =
    t ||
    function(a) {
      return '[object Array]' === l.call(a);
    };
  g.isObject = function(a) {
    var d = typeof a;
    return 'function' === d || ('object' === d && !!a);
  };
  g.each('Arguments Function String Number Date RegExp Error'.split(' '), function(a) {
    g['is' + a] = function(d) {
      return l.call(d) === '[object ' + a + ']';
    };
  });
  g.isArguments(arguments) ||
    (g.isArguments = function(a) {
      return g.has(a, 'callee');
    });
  'function' != typeof /./ &&
    'object' != typeof Int8Array &&
    (g.isFunction = function(a) {
      return 'function' == typeof a || !1;
    });
  g.isFinite = function(a) {
    return isFinite(a) && !isNaN(parseFloat(a));
  };
  g.isNaN = function(a) {
    return g.isNumber(a) && a !== +a;
  };
  g.isBoolean = function(a) {
    return !0 === a || !1 === a || '[object Boolean]' === l.call(a);
  };
  g.isNull = function(a) {
    return null === a;
  };
  g.isUndefined = function(a) {
    return void 0 === a;
  };
  g.has = function(a, c) {
    return null != a && d.call(a, c);
  };
  g.noConflict = function() {
    r._ = k;
    return this;
  };
  g.identity = function(a) {
    return a;
  };
  g.constant = function(a) {
    return function() {
      return a;
    };
  };
  g.noop = function() {};
  g.property = z;
  g.propertyOf = function(a) {
    return null == a
      ? function() {}
      : function(d) {
          return a[d];
        };
  };
  g.matcher = g.matches = function(a) {
    a = g.extendOwn({}, a);
    return function(d) {
      return g.isMatch(d, a);
    };
  };
  g.times = function(a, d, c) {
    var f = Array(Math.max(0, a));
    d = j(d, c, 1);
    for (c = 0; c < a; c++) f[c] = d(c);
    return f;
  };
  g.random = function(a, d) {
    null == d && ((d = a), (a = 0));
    return a + Math.floor(Math.random() * (d - a + 1));
  };
  g.now =
    Date.now ||
    function() {
      return new Date().getTime();
    };
  t = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;', '`': '&#x60;' };
  w = g.invert(t);
  z = function(a) {
    var d = function(d) {
        return a[d];
      },
      c = '(?:' + g.keys(a).join('|') + ')',
      f = RegExp(c),
      q = RegExp(c, 'g');
    return function(a) {
      a = null == a ? '' : '' + a;
      return f.test(a) ? a.replace(q, d) : a;
    };
  };
  g.escape = z(t);
  g.unescape = z(w);
  g.result = function(a, d, c) {
    d = null == a ? void 0 : a[d];
    void 0 === d && (d = c);
    return g.isFunction(d) ? d.call(a) : d;
  };
  var L = 0;
  g.uniqueId = function(a) {
    var d = ++L + '';
    return a ? a + d : d;
  };
  g.templateSettings = { evaluate: /<%([\s\S]+?)%>/g, interpolate: /<%=([\s\S]+?)%>/g, escape: /<%-([\s\S]+?)%>/g };
  var J = /(.)^/,
    P = { "'": "'", '\\': '\\', '\r': 'r', '\n': 'n', '\u2028': 'u2028', '\u2029': 'u2029' },
    M = /\\|'|\r|\n|\u2028|\u2029/g,
    Q = function(a) {
      return '\\' + P[a];
    };
  g.template = function(a, d, c) {
    !d && c && (d = c);
    d = g.defaults({}, d, g.templateSettings);
    c = RegExp([(d.escape || J).source, (d.interpolate || J).source, (d.evaluate || J).source].join('|') + '|$', 'g');
    var f = 0,
      q = "__p+='";
    a.replace(c, function(d, c, g, j, e) {
      q += a.slice(f, e).replace(M, Q);
      f = e + d.length;
      c
        ? (q += "'+\n((__t=(" + c + "))==null?'':_.escape(__t))+\n'")
        : g
        ? (q += "'+\n((__t=(" + g + "))==null?'':__t)+\n'")
        : j && (q += "';\n" + j + "\n__p+='");
      return d;
    });
    q += "';\n";
    d.variable || (q = 'with(obj||{}){\n' + q + '}\n');
    q =
      "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + q + 'return __p;\n';
    try {
      var j = new Function(d.variable || 'obj', '_', q);
    } catch (e) {
      throw ((e.source = q), e);
    }
    c = function(a) {
      return j.call(this, a, g);
    };
    c.source = 'function(' + (d.variable || 'obj') + '){\n' + q + '}';
    return c;
  };
  g.chain = function(a) {
    a = g(a);
    a._chain = !0;
    return a;
  };
  var N = function(a, d) {
    return a._chain ? g(d).chain() : d;
  };
  g.mixin = function(a) {
    g.each(g.functions(a), function(d) {
      var f = (g[d] = a[d]);
      g.prototype[d] = function() {
        var a = [this._wrapped];
        c.apply(a, arguments);
        return N(this, f.apply(g, a));
      };
    });
  };
  g.mixin(g);
  g.each('pop push reverse shift sort splice unshift'.split(' '), function(a) {
    var d = m[a];
    g.prototype[a] = function() {
      var c = this._wrapped;
      d.apply(c, arguments);
      ('shift' === a || 'splice' === a) && 0 === c.length && delete c[0];
      return N(this, c);
    };
  });
  g.each(['concat', 'join', 'slice'], function(a) {
    var d = m[a];
    g.prototype[a] = function() {
      return N(this, d.apply(this._wrapped, arguments));
    };
  });
  g.prototype.value = function() {
    return this._wrapped;
  };
  g.prototype.valueOf = g.prototype.toJSON = g.prototype.value;
  g.prototype.toString = function() {
    return '' + this._wrapped;
  };
  'function' === typeof define &&
    define.amd &&
    define('underscore', [], function() {
      return g;
    });
}.call(this));
(function() {
  var e = this.Backbone || {};
  this.Backbone = e;
  var h = [].slice,
    p = function(e, h, m) {
      var a;
      e = -1;
      var c = h.length;
      switch (m.length) {
        case 0:
          for (; ++e < c; ) (a = h[e]).callback.call(a.ctx);
          break;
        case 1:
          for (; ++e < c; ) (a = h[e]).callback.call(a.ctx, m[0]);
          break;
        case 2:
          for (; ++e < c; ) (a = h[e]).callback.call(a.ctx, m[0], m[1]);
          break;
        case 3:
          for (; ++e < c; ) (a = h[e]).callback.call(a.ctx, m[0], m[1], m[2]);
          break;
        default:
          for (; ++e < c; ) (a = h[e]).callback.apply(a.ctx, m);
      }
    },
    n = (e.Events = {
      on: function(e, h, m) {
        this._events || (this._events = {});
        (this._events[e] || (this._events[e] = [])).push({ callback: h, context: m, ctx: m || this });
        return this;
      },
      once: function(e, h, m) {
        var a = this,
          c = _.once(function() {
            a.off(e, c);
            h.apply(this, arguments);
          });
        c._callback = h;
        this.on(e, c, m);
        return this;
      },
      off: function(e, h, m) {
        var a, c, f, l, d, t, s, D;
        if (!this._events) return this;
        if (!e && !h && !m) return (this._events = {}), this;
        l = e ? [e] : _.keys(this._events);
        d = 0;
        for (t = l.length; d < t; d++)
          if (((e = l[d]), (a = this._events[e]))) {
            f = [];
            if (h || m) {
              s = 0;
              for (D = a.length; s < D; s++)
                (c = a[s]), ((h && h !== (c.callback._callback || c.callback)) || (m && m !== c.context)) && f.push(c);
            }
            this._events[e] = f;
          }
        return this;
      },
      trigger: function(e) {
        if (!this._events) return this;
        var k = h.call(arguments, 1),
          m = this._events[e],
          a = this._events.all;
        m && p(this, m, k);
        a && p(this, a, arguments);
        return this;
      },
      listenTo: function(e, h, m) {
        var a = this._listeners || (this._listeners = {}),
          c = e._listenerId || (e._listenerId = _.uniqueId('l'));
        a[c] = e;
        e.on(h, m || this, this);
        return this;
      },
      stopListening: function(e, h, m) {
        var a = this._listeners;
        if (a) {
          if (e) e.off(h, m, this), !h && !m && delete a[e._listenerId];
          else {
            for (var c in a) a[c].off(null, null, this);
            this._listeners = {};
          }
          return this;
        }
      },
    });
  n.bind = n.on;
  n.unbind = n.off;
  'undefined' !== typeof exports
    ? ('undefined' !== typeof module && module.exports && (exports = module.exports = e), (exports.Backbone = e))
    : (this.Backbone = e);
  'function' === typeof define &&
    define.amd &&
    define('backbone', [], function() {
      return e;
    });
})();
(function() {
  function e(e) {
    var m = new Date().getTime(),
      a = Math.max(0, 16 - (m - p)),
      c = h.setTimeout(function() {
        e(m + a);
      }, a);
    p = m + a;
    return c;
  }
  for (var h = this, p = 0, n = ['ms', 'moz', 'webkit', 'o'], r = 0; r < n.length && !h.requestAnimationFrame; ++r)
    (h.requestAnimationFrame = h[n[r] + 'RequestAnimationFrame']),
      (h.cancelAnimationFrame = h[n[r] + 'CancelAnimationFrame'] || h[n[r] + 'CancelRequestAnimationFrame']);
  h.requestAnimationFrame || (h.requestAnimationFrame = e);
  h.cancelAnimationFrame ||
    (h.cancelAnimationFrame = function(e) {
      clearTimeout(e);
    });
  'undefined' !== typeof exports
    ? ('undefined' !== typeof module && module.exports && (exports = module.exports = h.requestAnimationFrame),
      (exports.requestAnimationFrame = h.requestAnimationFrame))
    : (h.requestAnimationFrame = h.requestAnimationFrame);
  'function' === typeof define &&
    define.amd &&
    define('requestAnimationFrame', [], function() {
      return h.requestAnimationFrame;
    });
})();
(function(e, h, p, n) {
  function r() {
    var a = document.body.getBoundingClientRect(),
      d = (this.width = a.width),
      a = (this.height = a.height);
    this.renderer.setSize(d, a, this.ratio);
    this.trigger(j.Events.resize, d, a);
  }
  var k = this,
    m = Math.sin,
    a = Math.cos,
    c = Math.atan2,
    f = Math.sqrt,
    l = Math.PI,
    d = 2 * l,
    t = l / 2,
    s = Math.pow,
    D = Math.min,
    y = Math.max,
    u = 0,
    g = {
      temp: document.createElement('div'),
      hasEventListeners: h.isFunction(k.addEventListener),
      bind: function(a, d, c, f) {
        this.hasEventListeners ? a.addEventListener(d, c, !!f) : a.attachEvent('on' + d, c);
        return this;
      },
      unbind: function(a, d, c, f) {
        this.hasEventListeners ? a.removeEventListeners(d, c, !!f) : a.detachEvent('on' + d, c);
        return this;
      },
    },
    j = (k.Two = function(a) {
      a = h.defaults(a || {}, { fullscreen: !1, width: 640, height: 480, type: j.Types.svg, autostart: !1 });
      h.each(
        a,
        function(a, d) {
          'fullscreen' === d || ('width' === d || 'height' === d || 'autostart' === d) || (this[d] = a);
        },
        this,
      );
      if (h.isElement(a.domElement)) {
        var d = a.domElement.tagName.toLowerCase();
        /^(CanvasRenderer-canvas|WebGLRenderer-canvas|SVGRenderer-svg)$/.test(this.type + '-' + d) ||
          (this.type = j.Types[d]);
      }
      this.renderer = new j[this.type](this);
      j.Utils.setPlaying.call(this, a.autostart);
      this.frameCount = 0;
      a.fullscreen
        ? ((a = h.bind(r, this)),
          h.extend(document.body.style, {
            overflow: 'hidden',
            margin: 0,
            padding: 0,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            position: 'fixed',
          }),
          h.extend(this.renderer.domElement.style, {
            display: 'block',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            position: 'fixed',
          }),
          g.bind(k, 'resize', a),
          a())
        : h.isElement(a.domElement) ||
          (this.renderer.setSize(a.width, a.height, this.ratio), (this.width = a.width), (this.height = a.height));
      this.scene = this.renderer.scene;
      j.Instances.push(this);
    });
  h.extend(j, {
    Array: k.Float32Array || Array,
    Types: { webgl: 'WebGLRenderer', svg: 'SVGRenderer', canvas: 'CanvasRenderer' },
    Version: 'v0.6.0',
    Identifier: 'two_',
    Properties: { hierarchy: 'hierarchy', demotion: 'demotion' },
    Events: {
      play: 'play',
      pause: 'pause',
      update: 'update',
      render: 'render',
      resize: 'resize',
      change: 'change',
      remove: 'remove',
      insert: 'insert',
      order: 'order',
    },
    Commands: { move: 'M', line: 'L', curve: 'C', close: 'Z' },
    Resolution: 8,
    Instances: [],
    noConflict: function() {
      k.Two = e;
      return this;
    },
    uniqueId: function() {
      var a = u;
      u++;
      return a;
    },
    Utils: {
      defineProperty: function(a) {
        var d = '_' + a,
          c = '_flag' + a.charAt(0).toUpperCase() + a.slice(1);
        Object.defineProperty(this, a, {
          get: function() {
            return this[d];
          },
          set: function(a) {
            this[d] = a;
            this[c] = !0;
          },
        });
      },
      release: function(a) {
        h.isObject(a) &&
          (h.isFunction(a.unbind) && a.unbind(),
          a.vertices &&
            (h.isFunction(a.vertices.unbind) && a.vertices.unbind(),
            h.each(a.vertices, function(a) {
              h.isFunction(a.unbind) && a.unbind();
            })),
          a.children &&
            h.each(a.children, function(a) {
              j.Utils.release(a);
            }));
      },
      xhr: function(a, d) {
        var c = new XMLHttpRequest();
        c.open('GET', a);
        c.onreadystatechange = function() {
          4 === c.readyState && 200 === c.status && d(c.responseText);
        };
        c.send();
        return c;
      },
      Curve: {
        CollinearityEpsilon: s(10, -30),
        RecursionLimit: 16,
        CuspLimit: 0,
        Tolerance: { distance: 0.25, angle: 0, epsilon: 0.01 },
        abscissas: [
          [0.5773502691896257],
          [0, 0.7745966692414834],
          [0.33998104358485626, 0.8611363115940526],
          [0, 0.5384693101056831, 0.906179845938664],
          [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
          [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
          [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
          [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
          [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
          [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
          [
            0.1252334085114689,
            0.3678314989981802,
            0.5873179542866175,
            0.7699026741943047,
            0.9041172563704749,
            0.9815606342467192,
          ],
          [
            0,
            0.2304583159551348,
            0.44849275103644687,
            0.6423493394403402,
            0.8015780907333099,
            0.9175983992229779,
            0.9841830547185881,
          ],
          [
            0.10805494870734367,
            0.31911236892788974,
            0.5152486363581541,
            0.6872929048116855,
            0.827201315069765,
            0.9284348836635735,
            0.9862838086968123,
          ],
          [
            0,
            0.20119409399743451,
            0.3941513470775634,
            0.5709721726085388,
            0.7244177313601701,
            0.8482065834104272,
            0.937273392400706,
            0.9879925180204854,
          ],
          [
            0.09501250983763744,
            0.2816035507792589,
            0.45801677765722737,
            0.6178762444026438,
            0.755404408355003,
            0.8656312023878318,
            0.9445750230732326,
            0.9894009349916499,
          ],
        ],
        weights: [
          [1],
          [0.8888888888888888, 0.5555555555555556],
          [0.6521451548625461, 0.34785484513745385],
          [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
          [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
          [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
          [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
          [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
          [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
          [
            0.2729250867779006,
            0.26280454451024665,
            0.23319376459199048,
            0.18629021092773426,
            0.1255803694649046,
            0.05566856711617366,
          ],
          [
            0.24914704581340277,
            0.2334925365383548,
            0.20316742672306592,
            0.16007832854334622,
            0.10693932599531843,
            0.04717533638651183,
          ],
          [
            0.2325515532308739,
            0.22628318026289723,
            0.2078160475368885,
            0.17814598076194574,
            0.13887351021978725,
            0.09212149983772845,
            0.04048400476531588,
          ],
          [
            0.2152638534631578,
            0.2051984637212956,
            0.18553839747793782,
            0.15720316715819355,
            0.12151857068790319,
            0.08015808715976021,
            0.03511946033175186,
          ],
          [
            0.2025782419255613,
            0.19843148532711158,
            0.1861610000155622,
            0.16626920581699392,
            0.13957067792615432,
            0.10715922046717194,
            0.07036604748810812,
            0.03075324199611727,
          ],
          [
            0.1894506104550685,
            0.18260341504492358,
            0.16915651939500254,
            0.14959598881657674,
            0.12462897125553388,
            0.09515851168249279,
            0.062253523938647894,
            0.027152459411754096,
          ],
        ],
      },
      devicePixelRatio: k.devicePixelRatio || 1,
      getBackingStoreRatio: function(a) {
        return (
          a.webkitBackingStorePixelRatio ||
          a.mozBackingStorePixelRatio ||
          a.msBackingStorePixelRatio ||
          a.oBackingStorePixelRatio ||
          a.backingStorePixelRatio ||
          1
        );
      },
      getRatio: function(a) {
        return j.Utils.devicePixelRatio / A(a);
      },
      setPlaying: function(a) {
        this.playing = !!a;
        return this;
      },
      getComputedMatrix: function(a, d) {
        d = (d && d.identity()) || new j.Matrix();
        for (var c = a, f = []; c && c._matrix; ) f.push(c._matrix), (c = c.parent);
        f.reverse();
        h.each(f, function(a) {
          a = a.elements;
          d.multiply(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
        });
        return d;
      },
      deltaTransformPoint: function(a, d, c) {
        return new j.Vector(d * a.a + c * a.c + 0, d * a.b + c * a.d + 0);
      },
      decomposeMatrix: function(a) {
        var d = j.Utils.deltaTransformPoint(a, 0, 1),
          c = j.Utils.deltaTransformPoint(a, 1, 0),
          d = (180 / Math.PI) * Math.atan2(d.y, d.x) - 90,
          c = (180 / Math.PI) * Math.atan2(c.y, c.x);
        return {
          translateX: a.e,
          translateY: a.f,
          scaleX: Math.sqrt(a.a * a.a + a.b * a.b),
          scaleY: Math.sqrt(a.c * a.c + a.d * a.d),
          skewX: d,
          skewY: c,
          rotation: d,
        };
      },
      applySvgAttributes: function(a, d) {
        var c = {},
          f = {},
          g,
          e,
          l;
        if (getComputedStyle) {
          var s = getComputedStyle(a);
          for (g = s.length; g--; ) (e = s[g]), (l = s[e]), void 0 !== l && (f[e] = l);
        }
        for (g = a.attributes.length; g--; ) (l = a.attributes[g]), (c[l.nodeName] = l.value);
        h.isUndefined(f.opacity) || ((f['stroke-opacity'] = f.opacity), (f['fill-opacity'] = f.opacity));
        h.extend(f, c);
        f.visible =
          !(h.isUndefined(f.display) && 'none' === f.display) ||
          (h.isUndefined(f.visibility) && 'hidden' === f.visibility);
        for (e in f)
          switch (((l = f[e]), e)) {
            case 'transform':
              if ('none' === l) break;
              if (null === a.getCTM()) break;
              c = j.Utils.decomposeMatrix(a.getCTM());
              d.translation.set(c.translateX, c.translateY);
              d.rotation = c.rotation;
              d.scale = c.scaleX;
              f.x && (d.translation.x = f.x);
              f.y && (d.translation.y = f.y);
              break;
            case 'visible':
              d.visible = l;
              break;
            case 'stroke-linecap':
              d.cap = l;
              break;
            case 'stroke-linejoin':
              d.join = l;
              break;
            case 'stroke-miterlimit':
              d.miter = l;
              break;
            case 'stroke-width':
              d.linewidth = parseFloat(l);
              break;
            case 'stroke-opacity':
            case 'fill-opacity':
            case 'opacity':
              d.opacity = parseFloat(l);
              break;
            case 'fill':
            case 'stroke':
              d[e] = /url\(\#.*\)/i.test(l)
                ? this.getById(l.replace(/url\(\#(.*)\)/i, '$1'))
                : 'none' === l
                ? 'transparent'
                : l;
              break;
            case 'id':
              d.id = l;
              break;
            case 'class':
              d.classList = l.split(' ');
          }
        return d;
      },
      read: {
        svg: function() {
          return j.Utils.read.g.apply(this, arguments);
        },
        g: function(a) {
          var d = new j.Group();
          j.Utils.applySvgAttributes.call(this, a, d);
          for (var c = 0, f = a.childNodes.length; c < f; c++) {
            var g = a.childNodes[c],
              e = g.nodeName;
            if (!e) return;
            e = e.replace(/svg\:/gi, '').toLowerCase();
            e in j.Utils.read && ((g = j.Utils.read[e].call(d, g)), d.add(g));
          }
          return d;
        },
        polygon: function(a, d) {
          var c = [];
          a.getAttribute('points').replace(/(-?[\d\.?]+),(-?[\d\.?]+)/g, function(a, d, f) {
            c.push(new j.Anchor(parseFloat(d), parseFloat(f)));
          });
          var f = new j.Path(c, !d).noStroke();
          f.fill = 'black';
          return j.Utils.applySvgAttributes.call(this, a, f);
        },
        polyline: function(a) {
          return j.Utils.read.polygon.call(this, a, !0);
        },
        path: function(a) {
          var d = a.getAttribute('d'),
            c = new j.Anchor(),
            f,
            g,
            e = !1,
            l = !1,
            t = d.match(/[a-df-z][^a-df-z]*/gi),
            D = t.length - 1;
          h.each(t.slice(0), function(a, d) {
            var c = a[0],
              f = c.toLowerCase(),
              g = a
                .slice(1)
                .trim()
                .split(/[\s,]+|(?=\s?[+\-])/),
              e = [],
              j;
            0 >= d && (t = []);
            switch (f) {
              case 'h':
              case 'v':
                1 < g.length && (j = 1);
                break;
              case 'm':
              case 'l':
              case 't':
                2 < g.length && (j = 2);
                break;
              case 's':
              case 'q':
                4 < g.length && (j = 4);
                break;
              case 'c':
                6 < g.length && (j = 6);
            }
            if (j) {
              for (var f = 0, l = g.length, q = 0; f < l; f += j) {
                var h = c;
                if (0 < q)
                  switch (c) {
                    case 'm':
                      h = 'l';
                      break;
                    case 'M':
                      h = 'L';
                  }
                e.push([h].concat(g.slice(f, f + j)).join(' '));
                q++;
              }
              t = Array.prototype.concat.apply(t, e);
            } else t.push(a);
          });
          d = h.flatten(
            h.map(t, function(a, d) {
              var q, t, B;
              t = a[0];
              var k = t.toLowerCase();
              g = a.slice(1).trim();
              g = g.replace(/(-?\d+(?:\.\d*)?)[eE]([+\-]?\d+)/g, function(a, d, c) {
                return parseFloat(d) * s(10, c);
              });
              g = g.split(/[\s,]+|(?=\s?[+\-])/);
              l = t === k;
              var m, u, y, n;
              switch (k) {
                case 'z':
                  d >= D
                    ? (e = !0)
                    : ((t = c.x),
                      (B = c.y),
                      (q = new j.Anchor(t, B, void 0, void 0, void 0, void 0, j.Commands.close)));
                  break;
                case 'm':
                case 'l':
                  t = parseFloat(g[0]);
                  B = parseFloat(g[1]);
                  q = new j.Anchor(t, B, void 0, void 0, void 0, void 0, 'm' === k ? j.Commands.move : j.Commands.line);
                  l && q.addSelf(c);
                  c = q;
                  break;
                case 'h':
                case 'v':
                  B = 'h' === k ? 'x' : 'y';
                  k = 'x' === B ? 'y' : 'x';
                  q = new j.Anchor(void 0, void 0, void 0, void 0, void 0, void 0, j.Commands.line);
                  q[B] = parseFloat(g[0]);
                  q[k] = c[k];
                  l && (q[B] += c[B]);
                  c = q;
                  break;
                case 'c':
                case 's':
                  q = c.x;
                  B = c.y;
                  f || (f = new j.Vector());
                  'c' === k
                    ? ((m = parseFloat(g[0])),
                      (u = parseFloat(g[1])),
                      (y = parseFloat(g[2])),
                      (n = parseFloat(g[3])),
                      (k = parseFloat(g[4])),
                      (t = parseFloat(g[5])))
                    : ((k = G(c, f, l)),
                      (m = k.x),
                      (u = k.y),
                      (y = parseFloat(g[0])),
                      (n = parseFloat(g[1])),
                      (k = parseFloat(g[2])),
                      (t = parseFloat(g[3])));
                  l && ((m += q), (u += B), (y += q), (n += B), (k += q), (t += B));
                  h.isObject(c.controls) || j.Anchor.AppendCurveProperties(c);
                  c.controls.right.set(m - c.x, u - c.y);
                  c = q = new j.Anchor(k, t, y - k, n - t, void 0, void 0, j.Commands.curve);
                  f = q.controls.left;
                  break;
                case 't':
                case 'q':
                  q = c.x;
                  B = c.y;
                  f || (f = new j.Vector());
                  f.isZero() ? ((m = q), (u = B)) : ((m = f.x), (B = f.y));
                  'q' === k
                    ? ((y = parseFloat(g[0])), (n = parseFloat(g[1])), (k = parseFloat(g[1])), (t = parseFloat(g[2])))
                    : ((k = G(c, f, l)), (y = k.x), (n = k.y), (k = parseFloat(g[0])), (t = parseFloat(g[1])));
                  l && ((m += q), (u += B), (y += q), (n += B), (k += q), (t += B));
                  h.isObject(c.controls) || j.Anchor.AppendCurveProperties(c);
                  c.controls.right.set(m - c.x, u - c.y);
                  c = q = new j.Anchor(k, t, y - k, n - t, void 0, void 0, j.Commands.curve);
                  f = q.controls.left;
                  break;
                case 'a':
                  q = c.x;
                  B = c.y;
                  var r = parseFloat(g[0]),
                    x = parseFloat(g[1]);
                  u = (parseFloat(g[2]) * Math.PI) / 180;
                  m = parseFloat(g[3]);
                  y = parseFloat(g[4]);
                  k = parseFloat(g[5]);
                  t = parseFloat(g[6]);
                  l && ((k += q), (t += B));
                  var w = (k - q) / 2,
                    p = (t - B) / 2;
                  n = w * Math.cos(u) + p * Math.sin(u);
                  var w = -w * Math.sin(u) + p * Math.cos(u),
                    p = r * r,
                    v = x * x,
                    z = n * n,
                    A = w * w,
                    M = z / p + A / v;
                  1 < M && ((r *= Math.sqrt(M)), (x *= Math.sqrt(M)));
                  v = Math.sqrt((p * v - p * A - v * z) / (p * A + v * z));
                  h.isNaN(v) ? (v = 0) : m != y && 0 < v && (v *= -1);
                  p = (v * r * w) / x;
                  v = (-v * x * n) / r;
                  q = p * Math.cos(u) - v * Math.sin(u) + (q + k) / 2;
                  var z = p * Math.sin(u) + v * Math.cos(u) + (B + t) / 2,
                    C = function(a, d) {
                      return (
                        (a[0] * d[0] + a[1] * d[1]) /
                        (Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2)) *
                          Math.sqrt(Math.pow(d[0], 2) + Math.pow(d[1], 2)))
                      );
                    };
                  B = function(a, d) {
                    return (a[0] * d[1] < a[1] * d[0] ? -1 : 1) * Math.acos(C(a, d));
                  };
                  var F = B([1, 0], [(n - p) / r, (w - v) / x]),
                    A = [(n - p) / r, (w - v) / x];
                  n = [(-n - p) / r, (-w - v) / x];
                  var H = B(A, n);
                  -1 >= C(A, n) && (H = Math.PI);
                  1 <= C(A, n) && (H = 0);
                  m && (H = E(H, 2 * Math.PI));
                  y && 0 < H && (H -= 2 * Math.PI);
                  var O = j.Resolution,
                    R = new j.Matrix().translate(q, z).rotate(u);
                  q = h.map(h.range(O), function(a) {
                    var d = (1 - a / (O - 1)) * H + F;
                    a = r * Math.cos(d);
                    d = x * Math.sin(d);
                    a = R.multiply(a, d, 1);
                    return new j.Anchor(a.x, a.y, !1, !1, !1, !1, j.Commands.line);
                  });
                  q.push(new j.Anchor(k, t, !1, !1, !1, !1, j.Commands.line));
                  c = q[q.length - 1];
                  f = c.controls.left;
              }
              return q;
            }),
          );
          if (!(1 >= d.length))
            return (
              (d = h.compact(d)),
              (d = new j.Path(d, e, void 0, !0).noStroke()),
              (d.fill = 'black'),
              j.Utils.applySvgAttributes.call(this, a, d)
            );
        },
        circle: function(c) {
          var f = parseFloat(c.getAttribute('cx')),
            g = parseFloat(c.getAttribute('cy')),
            e = parseFloat(c.getAttribute('r')),
            l = j.Resolution,
            t = h.map(h.range(l), function(c) {
              var f = (c / l) * d;
              c = e * a(f);
              f = e * m(f);
              return new j.Anchor(c, f);
            }),
            t = new j.Path(t, !0, !0).noStroke();
          t.translation.set(f, g);
          t.fill = 'black';
          return j.Utils.applySvgAttributes.call(this, c, t);
        },
        ellipse: function(c) {
          var f = parseFloat(c.getAttribute('cx')),
            g = parseFloat(c.getAttribute('cy')),
            e = parseFloat(c.getAttribute('rx')),
            l = parseFloat(c.getAttribute('ry')),
            t = j.Resolution,
            s = h.map(h.range(t), function(c) {
              var f = (c / t) * d;
              c = e * a(f);
              f = l * m(f);
              return new j.Anchor(c, f);
            }),
            s = new j.Path(s, !0, !0).noStroke();
          s.translation.set(f, g);
          s.fill = 'black';
          return j.Utils.applySvgAttributes.call(this, c, s);
        },
        rect: function(a) {
          var d = parseFloat(a.getAttribute('x')) || 0,
            c = parseFloat(a.getAttribute('y')) || 0,
            f = parseFloat(a.getAttribute('width')),
            g = parseFloat(a.getAttribute('height')),
            f = f / 2,
            g = g / 2,
            e = [new j.Anchor(f, g), new j.Anchor(-f, g), new j.Anchor(-f, -g), new j.Anchor(f, -g)],
            e = new j.Path(e, !0).noStroke();
          e.translation.set(d + f, c + g);
          e.fill = 'black';
          return j.Utils.applySvgAttributes.call(this, a, e);
        },
        line: function(a) {
          var d = parseFloat(a.getAttribute('x1')),
            c = parseFloat(a.getAttribute('y1')),
            f = parseFloat(a.getAttribute('x2')),
            g = parseFloat(a.getAttribute('y2')),
            f = (f - d) / 2,
            g = (g - c) / 2,
            e = [new j.Anchor(-f, -g), new j.Anchor(f, g)],
            e = new j.Path(e).noFill();
          e.translation.set(d + f, c + g);
          return j.Utils.applySvgAttributes.call(this, a, e);
        },
        lineargradient: function(a) {
          for (
            var d = parseFloat(a.getAttribute('x1')),
              c = parseFloat(a.getAttribute('y1')),
              f = parseFloat(a.getAttribute('x2')),
              g = parseFloat(a.getAttribute('y2')),
              e = (f + d) / 2,
              l = (g + c) / 2,
              t = [],
              s = 0;
            s < a.children.length;
            s++
          ) {
            var k = a.children[s],
              D = parseFloat(k.getAttribute('offset')),
              u = k.getAttribute('stop-color'),
              m = k.getAttribute('stop-opacity'),
              k = k.getAttribute('style');
            if (h.isNull(u))
              var n = k.match(/stop\-color\:\s?([\#a-fA-F0-9]*)/),
                u = n && 1 < n.length ? n[1] : void 0;
            h.isNull(m) && (m = (n = k.match(/stop\-opacity\:\s?([0-1\.\-]*)/)) && 1 < n.length ? parseFloat(n[1]) : 1);
            t.push(new j.Gradient.Stop(D, u, m));
          }
          d = new j.LinearGradient(d - e, c - l, f - e, g - l, t);
          return j.Utils.applySvgAttributes.call(this, a, d);
        },
        radialgradient: function(a) {
          var d = parseFloat(a.getAttribute('cx')) || 0,
            c = parseFloat(a.getAttribute('cy')) || 0,
            f = parseFloat(a.getAttribute('r')),
            g = parseFloat(a.getAttribute('fx')),
            e = parseFloat(a.getAttribute('fy'));
          h.isNaN(g) && (g = d);
          h.isNaN(e) && (e = c);
          for (var l = Math.abs(d + g) / 2, t = Math.abs(c + e) / 2, s = [], k = 0; k < a.children.length; k++) {
            var D = a.children[k],
              u = parseFloat(D.getAttribute('offset')),
              n = D.getAttribute('stop-color'),
              m = D.getAttribute('stop-opacity'),
              D = D.getAttribute('style');
            if (h.isNull(n))
              var y = D.match(/stop\-color\:\s?([\#a-fA-F0-9]*)/),
                n = y && 1 < y.length ? y[1] : void 0;
            h.isNull(m) && (m = (y = D.match(/stop\-opacity\:\s?([0-1\.\-]*)/)) && 1 < y.length ? parseFloat(y[1]) : 1);
            s.push(new j.Gradient.Stop(u, n, m));
          }
          d = new j.RadialGradient(d - l, c - t, f, s, g - l, e - t);
          return j.Utils.applySvgAttributes.call(this, a, d);
        },
      },
      subdivide: function(a, d, c, f, g, e, l, t, s) {
        s = s || j.Utils.Curve.RecursionLimit;
        var k = s + 1;
        return a === l && d === t
          ? [new j.Anchor(l, t)]
          : h.map(h.range(0, k), function(h) {
              var s = h / k;
              h = C(s, a, c, g, l);
              s = C(s, d, f, e, t);
              return new j.Anchor(h, s);
            });
      },
      getPointOnCubicBezier: function(a, d, c, f, g) {
        var e = 1 - a;
        return e * e * e * d + 3 * e * e * a * c + 3 * e * a * a * f + a * a * a * g;
      },
      getCurveLength: function(a, d, c, g, e, l, h, t, s) {
        if (a === c && d === g && e === h && l === t) return (a = h - a), (d = t - d), f(a * a + d * d);
        var k = 9 * (c - e) + 3 * (h - a),
          D = 6 * (a + e) - 12 * c,
          u = 3 * (c - a),
          n = 9 * (g - l) + 3 * (t - d),
          m = 6 * (d + l) - 12 * g,
          y = 3 * (g - d);
        return F(
          function(a) {
            var d = (k * a + D) * a + u;
            a = (n * a + m) * a + y;
            return f(d * d + a * a);
          },
          0,
          1,
          s || j.Utils.Curve.RecursionLimit,
        );
      },
      integrate: function(a, d, c, f) {
        var g = j.Utils.Curve.abscissas[f - 2],
          e = j.Utils.Curve.weights[f - 2];
        c = 0.5 * (c - d);
        d = c + d;
        var l = 0,
          h = (f + 1) >> 1;
        for (f = f & 1 ? e[l++] * a(d) : 0; l < h; ) {
          var t = c * g[l];
          f += e[l++] * (a(d + t) + a(d - t));
        }
        return c * f;
      },
      getCurveFromPoints: function(a, d) {
        for (var c = a.length, f = c - 1, g = 0; g < c; g++) {
          var e = a[g];
          h.isObject(e.controls) || j.Anchor.AppendCurveProperties(e);
          var l = d ? E(g - 1, c) : y(g - 1, 0),
            t = d ? E(g + 1, c) : D(g + 1, f);
          z(a[l], e, a[t]);
          e._command = 0 === g ? j.Commands.move : j.Commands.curve;
          e.controls.left.x = h.isNumber(e.controls.left.x) ? e.controls.left.x : e.x;
          e.controls.left.y = h.isNumber(e.controls.left.y) ? e.controls.left.y : e.y;
          e.controls.right.x = h.isNumber(e.controls.right.x) ? e.controls.right.x : e.x;
          e.controls.right.y = h.isNumber(e.controls.right.y) ? e.controls.right.y : e.y;
        }
      },
      getControlPoints: function(d, c, f) {
        var g = v(d, c),
          e = v(f, c);
        d = x(d, c);
        f = x(f, c);
        var s = (g + e) / 2;
        c.u = h.isObject(c.controls.left) ? c.controls.left : new j.Vector(0, 0);
        c.v = h.isObject(c.controls.right) ? c.controls.right : new j.Vector(0, 0);
        if (1e-4 > d || 1e-4 > f) return c._relative || (c.controls.left.copy(c), c.controls.right.copy(c)), c;
        d *= 0.33;
        f *= 0.33;
        s = e < g ? s + t : s - t;
        c.controls.left.x = a(s) * d;
        c.controls.left.y = m(s) * d;
        s -= l;
        c.controls.right.x = a(s) * f;
        c.controls.right.y = m(s) * f;
        c._relative ||
          ((c.controls.left.x += c.x),
          (c.controls.left.y += c.y),
          (c.controls.right.x += c.x),
          (c.controls.right.y += c.y));
        return c;
      },
      getReflection: function(a, d, c) {
        return new j.Vector(2 * a.x - (d.x + a.x) - (c ? a.x : 0), 2 * a.y - (d.y + a.y) - (c ? a.y : 0));
      },
      getAnchorsFromArcData: function(a, d, c, f, g, e, l) {
        new j.Matrix().translate(a.x, a.y).rotate(d);
        var t = j.Resolution;
        return h.map(h.range(t), function(a) {
          a = (a + 1) / t;
          l && (a = 1 - a);
          var d = a * e + g;
          a = c * Math.cos(d);
          d = f * Math.sin(d);
          a = new j.Anchor(a, d);
          j.Anchor.AppendCurveProperties(a);
          a.command = j.Commands.line;
          return a;
        });
      },
      ratioBetween: function(a, d) {
        return (a.x * d.x + a.y * d.y) / (a.length() * d.length());
      },
      angleBetween: function(a, d) {
        var f, g;
        if (4 <= arguments.length) return (f = arguments[0] - arguments[2]), (g = arguments[1] - arguments[3]), c(g, f);
        f = a.x - d.x;
        g = a.y - d.y;
        return c(g, f);
      },
      distanceBetweenSquared: function(a, d) {
        var c = a.x - d.x,
          f = a.y - d.y;
        return c * c + f * f;
      },
      distanceBetween: function(a, d) {
        return f(w(a, d));
      },
      toFixed: function(a) {
        return Math.floor(1e3 * a) / 1e3;
      },
      mod: function(a, d) {
        for (; 0 > a; ) a += d;
        return a % d;
      },
      Collection: function() {
        Array.call(this);
        1 < arguments.length
          ? Array.prototype.push.apply(this, arguments)
          : arguments[0] && Array.isArray(arguments[0]) && Array.prototype.push.apply(this, arguments[0]);
      },
      Error: function(a) {
        this.name = 'two.js';
        this.message = a;
      },
    },
  });
  j.Utils.Error.prototype = Error();
  j.Utils.Error.prototype.constructor = j.Utils.Error;
  j.Utils.Collection.prototype = [];
  j.Utils.Collection.constructor = j.Utils.Collection;
  h.extend(j.Utils.Collection.prototype, p.Events, {
    pop: function() {
      var a = Array.prototype.pop.apply(this, arguments);
      this.trigger(j.Events.remove, [a]);
      return a;
    },
    shift: function() {
      var a = Array.prototype.shift.apply(this, arguments);
      this.trigger(j.Events.remove, [a]);
      return a;
    },
    push: function() {
      var a = Array.prototype.push.apply(this, arguments);
      this.trigger(j.Events.insert, arguments);
      return a;
    },
    unshift: function() {
      var a = Array.prototype.unshift.apply(this, arguments);
      this.trigger(j.Events.insert, arguments);
      return a;
    },
    splice: function() {
      var a = Array.prototype.splice.apply(this, arguments),
        d;
      this.trigger(j.Events.remove, a);
      2 < arguments.length &&
        ((d = this.slice(arguments[0], arguments.length - 2)),
        this.trigger(j.Events.insert, d),
        this.trigger(j.Events.order));
      return a;
    },
    sort: function() {
      Array.prototype.sort.apply(this, arguments);
      this.trigger(j.Events.order);
      return this;
    },
    reverse: function() {
      Array.prototype.reverse.apply(this, arguments);
      this.trigger(j.Events.order);
      return this;
    },
  });
  var x = j.Utils.distanceBetween,
    w = j.Utils.distanceBetweenSquared,
    v = j.Utils.angleBetween,
    z = j.Utils.getControlPoints,
    E = j.Utils.mod,
    A = j.Utils.getBackingStoreRatio,
    C = j.Utils.getPointOnCubicBezier,
    F = j.Utils.integrate,
    G = j.Utils.getReflection;
  h.extend(j.prototype, p.Events, {
    appendTo: function(a) {
      a.appendChild(this.renderer.domElement);
      return this;
    },
    play: function() {
      j.Utils.setPlaying.call(this, !0);
      return this.trigger(j.Events.play);
    },
    pause: function() {
      this.playing = !1;
      return this.trigger(j.Events.pause);
    },
    update: function() {
      var a = !!this._lastFrame,
        d = (k.performance && k.performance.now ? k.performance : Date).now();
      this.frameCount++;
      a && (this.timeDelta = parseFloat((d - this._lastFrame).toFixed(3)));
      this._lastFrame = d;
      var a = this.width,
        d = this.height,
        c = this.renderer;
      (a !== c.width || d !== c.height) && c.setSize(a, d, this.ratio);
      this.trigger(j.Events.update, this.frameCount, this.timeDelta);
      return this.render();
    },
    render: function() {
      this.renderer.render();
      return this.trigger(j.Events.render, this.frameCount);
    },
    add: function(a) {
      var d = a;
      d instanceof Array || (d = h.toArray(arguments));
      this.scene.add(d);
      return this;
    },
    remove: function(a) {
      var d = a;
      d instanceof Array || (d = h.toArray(arguments));
      this.scene.remove(d);
      return this;
    },
    clear: function() {
      this.scene.remove(h.toArray(this.scene.children));
      return this;
    },
    makeLine: function(a, d, c, f) {
      a = new j.Line(a, d, c, f);
      this.scene.add(a);
      return a;
    },
    makeRectangle: function(a, d, c, f) {
      a = new j.Rectangle(a, d, c, f);
      this.scene.add(a);
      return a;
    },
    makeRoundedRectangle: function(a, d, c, f, g) {
      a = new j.RoundedRectangle(a, d, c, f, g);
      this.scene.add(a);
      return a;
    },
    makeCircle: function(a, d, c) {
      return this.makeEllipse(a, d, c, c);
    },
    makeEllipse: function(a, d, c, f) {
      a = new j.Ellipse(a, d, c, f);
      this.scene.add(a);
      return a;
    },
    makeStar: function(a, d, c, f, g) {
      a = new j.Star(a, d, c, f, g);
      this.scene.add(a);
      return a;
    },
    makeCurve: function(a) {
      var d = arguments.length,
        c = a;
      if (!h.isArray(a))
        for (var c = [], f = 0; f < d; f += 2) {
          var g = arguments[f];
          if (!h.isNumber(g)) break;
          c.push(new j.Anchor(g, arguments[f + 1]));
        }
      d = arguments[d - 1];
      c = new j.Path(c, !(h.isBoolean(d) && d), !0);
      d = c.getBoundingClientRect();
      c.center().translation.set(d.left + d.width / 2, d.top + d.height / 2);
      this.scene.add(c);
      return c;
    },
    makePolygon: function(a, d, c, f) {
      a = new j.Polygon(a, d, c, f);
      this.scene.add(a);
      return a;
    },
    makeArcSegment: function(a, d, c, f, g, e, l) {
      a = new j.ArcSegment(a, d, c, f, g, e, l);
      this.scene.add(a);
      return a;
    },
    makePath: function(a) {
      var d = arguments.length,
        c = a;
      if (!h.isArray(a))
        for (var c = [], f = 0; f < d; f += 2) {
          var g = arguments[f];
          if (!h.isNumber(g)) break;
          c.push(new j.Anchor(g, arguments[f + 1]));
        }
      d = arguments[d - 1];
      c = new j.Path(c, !(h.isBoolean(d) && d));
      d = c.getBoundingClientRect();
      c.center().translation.set(d.left + d.width / 2, d.top + d.height / 2);
      this.scene.add(c);
      return c;
    },
    makeText: function(a, d, c, f) {
      a = new j.Text(a, d, c, f);
      this.add(a);
      return a;
    },
    makeLinearGradient: function(a, d, c, f) {
      var g = Array.prototype.slice.call(arguments, 4),
        g = new j.LinearGradient(a, d, c, f, g);
      this.add(g);
      return g;
    },
    makeRadialGradient: function(a, d, c) {
      var f = Array.prototype.slice.call(arguments, 3),
        f = new j.RadialGradient(a, d, c, f);
      this.add(f);
      return f;
    },
    makeGroup: function(a) {
      var d = a;
      d instanceof Array || (d = h.toArray(arguments));
      var c = new j.Group();
      this.scene.add(c);
      c.add(d);
      return c;
    },
    interpret: function(a, d) {
      var c = a.tagName.toLowerCase();
      if (!(c in j.Utils.read)) return null;
      c = j.Utils.read[c].call(this, a);
      d && c instanceof j.Group ? this.add(c.children) : this.add(c);
      return c;
    },
    load: function(a, d) {
      var c = [],
        f,
        e;
      if (/.*\.svg/gi.test(a))
        return (
          j.Utils.xhr(
            a,
            h.bind(function(a) {
              g.temp.innerHTML = a;
              for (e = 0; e < g.temp.children.length; e++) (f = g.temp.children[e]), c.push(this.interpret(f));
              d(1 >= c.length ? c[0] : c, 1 >= g.temp.children.length ? g.temp.children[0] : g.temp.children);
            }, this),
          ),
          this
        );
      g.temp.innerHTML = a;
      for (e = 0; e < g.temp.children.length; e++) (f = g.temp.children[e]), c.push(this.interpret(f));
      d(1 >= c.length ? c[0] : c, 1 >= g.temp.children.length ? g.temp.children[0] : g.temp.children);
      return this;
    },
  });
  (function() {
    n(arguments.callee);
    j.Instances.forEach(function(a) {
      a.playing && a.update();
    });
  })();
  'function' === typeof define && define.amd
    ? define(function() {
        return j;
      })
    : 'undefined' != typeof module && module.exports && (module.exports = j);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h, p) {
  var n = (e.Vector = function(a, c) {
    this.x = a || 0;
    this.y = c || 0;
  });
  h.extend(n, { zero: new e.Vector() });
  h.extend(n.prototype, p.Events, {
    set: function(a, c) {
      this.x = a;
      this.y = c;
      return this;
    },
    copy: function(a) {
      this.x = a.x;
      this.y = a.y;
      return this;
    },
    clear: function() {
      this.y = this.x = 0;
      return this;
    },
    clone: function() {
      return new n(this.x, this.y);
    },
    add: function(a, c) {
      this.x = a.x + c.x;
      this.y = a.y + c.y;
      return this;
    },
    addSelf: function(a) {
      this.x += a.x;
      this.y += a.y;
      return this;
    },
    sub: function(a, c) {
      this.x = a.x - c.x;
      this.y = a.y - c.y;
      return this;
    },
    subSelf: function(a) {
      this.x -= a.x;
      this.y -= a.y;
      return this;
    },
    multiplySelf: function(a) {
      this.x *= a.x;
      this.y *= a.y;
      return this;
    },
    multiplyScalar: function(a) {
      this.x *= a;
      this.y *= a;
      return this;
    },
    divideScalar: function(a) {
      a ? ((this.x /= a), (this.y /= a)) : this.set(0, 0);
      return this;
    },
    negate: function() {
      return this.multiplyScalar(-1);
    },
    dot: function(a) {
      return this.x * a.x + this.y * a.y;
    },
    lengthSquared: function() {
      return this.x * this.x + this.y * this.y;
    },
    length: function() {
      return Math.sqrt(this.lengthSquared());
    },
    normalize: function() {
      return this.divideScalar(this.length());
    },
    distanceTo: function(a) {
      return Math.sqrt(this.distanceToSquared(a));
    },
    distanceToSquared: function(a) {
      var c = this.x - a.x;
      a = this.y - a.y;
      return c * c + a * a;
    },
    setLength: function(a) {
      return this.normalize().multiplyScalar(a);
    },
    equals: function(a, c) {
      return this.distanceTo(a) < ('undefined' === typeof c ? 1e-4 : c);
    },
    lerp: function(a, c) {
      return this.set((a.x - this.x) * c + this.x, (a.y - this.y) * c + this.y);
    },
    isZero: function(a) {
      return this.length() < ('undefined' === typeof a ? 1e-4 : a);
    },
    toString: function() {
      return this.x + ',' + this.y;
    },
    toObject: function() {
      return { x: this.x, y: this.y };
    },
  });
  var r = {
      set: function(a, c) {
        this._x = a;
        this._y = c;
        return this.trigger(e.Events.change);
      },
      copy: function(a) {
        this._x = a.x;
        this._y = a.y;
        return this.trigger(e.Events.change);
      },
      clear: function() {
        this._y = this._x = 0;
        return this.trigger(e.Events.change);
      },
      clone: function() {
        return new n(this._x, this._y);
      },
      add: function(a, c) {
        this._x = a.x + c.x;
        this._y = a.y + c.y;
        return this.trigger(e.Events.change);
      },
      addSelf: function(a) {
        this._x += a.x;
        this._y += a.y;
        return this.trigger(e.Events.change);
      },
      sub: function(a, c) {
        this._x = a.x - c.x;
        this._y = a.y - c.y;
        return this.trigger(e.Events.change);
      },
      subSelf: function(a) {
        this._x -= a.x;
        this._y -= a.y;
        return this.trigger(e.Events.change);
      },
      multiplySelf: function(a) {
        this._x *= a.x;
        this._y *= a.y;
        return this.trigger(e.Events.change);
      },
      multiplyScalar: function(a) {
        this._x *= a;
        this._y *= a;
        return this.trigger(e.Events.change);
      },
      divideScalar: function(a) {
        return a ? ((this._x /= a), (this._y /= a), this.trigger(e.Events.change)) : this.clear();
      },
      negate: function() {
        return this.multiplyScalar(-1);
      },
      dot: function(a) {
        return this._x * a.x + this._y * a.y;
      },
      lengthSquared: function() {
        return this._x * this._x + this._y * this._y;
      },
      length: function() {
        return Math.sqrt(this.lengthSquared());
      },
      normalize: function() {
        return this.divideScalar(this.length());
      },
      distanceTo: function(a) {
        return Math.sqrt(this.distanceToSquared(a));
      },
      distanceToSquared: function(a) {
        var c = this._x - a.x;
        a = this._y - a.y;
        return c * c + a * a;
      },
      setLength: function(a) {
        return this.normalize().multiplyScalar(a);
      },
      equals: function(a, c) {
        return this.distanceTo(a) < ('undefined' === typeof c ? 1e-4 : c);
      },
      lerp: function(a, c) {
        return this.set((a.x - this._x) * c + this._x, (a.y - this._y) * c + this._y);
      },
      isZero: function(a) {
        return this.length() < ('undefined' === typeof a ? 1e-4 : a);
      },
      toString: function() {
        return this._x + ',' + this._y;
      },
      toObject: function() {
        return { x: this._x, y: this._y };
      },
    },
    k = {
      get: function() {
        return this._x;
      },
      set: function(a) {
        this._x = a;
        this.trigger(e.Events.change, 'x');
      },
    },
    m = {
      get: function() {
        return this._y;
      },
      set: function(a) {
        this._y = a;
        this.trigger(e.Events.change, 'y');
      },
    };
  e.Vector.prototype.bind = e.Vector.prototype.on = function() {
    this._bound ||
      ((this._x = this.x),
      (this._y = this.y),
      Object.defineProperty(this, 'x', k),
      Object.defineProperty(this, 'y', m),
      h.extend(this, r),
      (this._bound = !0));
    p.Events.bind.apply(this, arguments);
    return this;
  };
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = e.Commands,
    n = (e.Anchor = function(k, m, a, c, f, l, d) {
      e.Vector.call(this, k, m);
      this._broadcast = h.bind(function() {
        this.trigger(e.Events.change);
      }, this);
      this._command = d || p.move;
      this._relative = !0;
      if (!d) return this;
      n.AppendCurveProperties(this);
      h.isNumber(a) && (this.controls.left.x = a);
      h.isNumber(c) && (this.controls.left.y = c);
      h.isNumber(f) && (this.controls.right.x = f);
      h.isNumber(l) && (this.controls.right.y = l);
    });
  h.extend(n, {
    AppendCurveProperties: function(h) {
      h.controls = { left: new e.Vector(0, 0), right: new e.Vector(0, 0) };
    },
  });
  var r = {
    listen: function() {
      h.isObject(this.controls) || n.AppendCurveProperties(this);
      this.controls.left.bind(e.Events.change, this._broadcast);
      this.controls.right.bind(e.Events.change, this._broadcast);
      return this;
    },
    ignore: function() {
      this.controls.left.unbind(e.Events.change, this._broadcast);
      this.controls.right.unbind(e.Events.change, this._broadcast);
      return this;
    },
    clone: function() {
      var h = this.controls,
        h = new e.Anchor(this.x, this.y, h && h.left.x, h && h.left.y, h && h.right.x, h && h.right.y, this.command);
      h.relative = this._relative;
      return h;
    },
    toObject: function() {
      var e = { x: this.x, y: this.y };
      this._command && (e.command = this._command);
      this._relative && (e.relative = this._relative);
      this.controls && (e.controls = { left: this.controls.left.toObject(), right: this.controls.right.toObject() });
      return e;
    },
  };
  Object.defineProperty(n.prototype, 'command', {
    get: function() {
      return this._command;
    },
    set: function(k) {
      this._command = k;
      this._command === p.curve && !h.isObject(this.controls) && n.AppendCurveProperties(this);
      return this.trigger(e.Events.change);
    },
  });
  Object.defineProperty(n.prototype, 'relative', {
    get: function() {
      return this._relative;
    },
    set: function(h) {
      if (this._relative == h) return this;
      this._relative = !!h;
      return this.trigger(e.Events.change);
    },
  });
  h.extend(n.prototype, e.Vector.prototype, r);
  e.Anchor.prototype.bind = e.Anchor.prototype.on = function() {
    e.Vector.prototype.bind.apply(this, arguments);
    h.extend(this, r);
  };
  e.Anchor.prototype.unbind = e.Anchor.prototype.off = function() {
    e.Vector.prototype.unbind.apply(this, arguments);
    h.extend(this, r);
  };
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h, p) {
  var n = Math.cos,
    r = Math.sin,
    k = Math.tan,
    m = (e.Matrix = function(a, c, f, l, d, t) {
      this.elements = new e.Array(9);
      var s = a;
      h.isArray(s) || (s = h.toArray(arguments));
      this.identity().set(s);
    });
  h.extend(m, {
    Identity: [1, 0, 0, 0, 1, 0, 0, 0, 1],
    Multiply: function(a, c, f) {
      if (3 >= c.length) {
        f = c[0] || 0;
        var l = c[1] || 0;
        c = c[2] || 0;
        return {
          x: a[0] * f + a[1] * l + a[2] * c,
          y: a[3] * f + a[4] * l + a[5] * c,
          z: a[6] * f + a[7] * l + a[8] * c,
        };
      }
      var l = a[0],
        d = a[1],
        h = a[2],
        s = a[3],
        k = a[4],
        n = a[5],
        u = a[6],
        g = a[7];
      a = a[8];
      var j = c[0],
        m = c[1],
        r = c[2],
        p = c[3],
        z = c[4],
        E = c[5],
        A = c[6],
        C = c[7];
      c = c[8];
      f = f || new e.Array(9);
      f[0] = l * j + d * p + h * A;
      f[1] = l * m + d * z + h * C;
      f[2] = l * r + d * E + h * c;
      f[3] = s * j + k * p + n * A;
      f[4] = s * m + k * z + n * C;
      f[5] = s * r + k * E + n * c;
      f[6] = u * j + g * p + a * A;
      f[7] = u * m + g * z + a * C;
      f[8] = u * r + g * E + a * c;
      return f;
    },
  });
  h.extend(m.prototype, p.Events, {
    set: function(a) {
      var c = a;
      h.isArray(c) || (c = h.toArray(arguments));
      h.extend(this.elements, c);
      return this.trigger(e.Events.change);
    },
    identity: function() {
      this.set(m.Identity);
      return this;
    },
    multiply: function(a, c, f, l, d, t, s, k, n) {
      var m = arguments,
        g = m.length;
      if (1 >= g)
        return (
          h.each(
            this.elements,
            function(d, c) {
              this.elements[c] = d * a;
            },
            this,
          ),
          this.trigger(e.Events.change)
        );
      if (3 >= g)
        return (
          (a = a || 0),
          (c = c || 0),
          (f = f || 0),
          (d = this.elements),
          { x: d[0] * a + d[1] * c + d[2] * f, y: d[3] * a + d[4] * c + d[5] * f, z: d[6] * a + d[7] * c + d[8] * f }
        );
      var j = this.elements,
        r = m,
        m = j[0],
        g = j[1],
        p = j[2],
        v = j[3],
        z = j[4],
        E = j[5],
        A = j[6],
        C = j[7],
        j = j[8],
        F = r[0],
        G = r[1],
        q = r[2],
        B = r[3],
        K = r[4],
        I = r[5],
        L = r[6],
        J = r[7],
        r = r[8];
      this.elements[0] = m * F + g * B + p * L;
      this.elements[1] = m * G + g * K + p * J;
      this.elements[2] = m * q + g * I + p * r;
      this.elements[3] = v * F + z * B + E * L;
      this.elements[4] = v * G + z * K + E * J;
      this.elements[5] = v * q + z * I + E * r;
      this.elements[6] = A * F + C * B + j * L;
      this.elements[7] = A * G + C * K + j * J;
      this.elements[8] = A * q + C * I + j * r;
      return this.trigger(e.Events.change);
    },
    inverse: function(a) {
      var c = this.elements;
      a = a || new e.Matrix();
      var f = c[0],
        l = c[1],
        d = c[2],
        h = c[3],
        s = c[4],
        k = c[5],
        m = c[6],
        n = c[7],
        c = c[8],
        g = c * s - k * n,
        j = -c * h + k * m,
        r = n * h - s * m,
        p = f * g + l * j + d * r;
      if (!p) return null;
      p = 1 / p;
      a.elements[0] = g * p;
      a.elements[1] = (-c * l + d * n) * p;
      a.elements[2] = (k * l - d * s) * p;
      a.elements[3] = j * p;
      a.elements[4] = (c * f - d * m) * p;
      a.elements[5] = (-k * f + d * h) * p;
      a.elements[6] = r * p;
      a.elements[7] = (-n * f + l * m) * p;
      a.elements[8] = (s * f - l * h) * p;
      return a;
    },
    scale: function(a, c) {
      1 >= arguments.length && (c = a);
      return this.multiply(a, 0, 0, 0, c, 0, 0, 0, 1);
    },
    rotate: function(a) {
      var c = n(a);
      a = r(a);
      return this.multiply(c, -a, 0, a, c, 0, 0, 0, 1);
    },
    translate: function(a, c) {
      return this.multiply(1, 0, a, 0, 1, c, 0, 0, 1);
    },
    skewX: function(a) {
      a = k(a);
      return this.multiply(1, a, 0, 0, 1, 0, 0, 0, 1);
    },
    skewY: function(a) {
      a = k(a);
      return this.multiply(1, 0, 0, a, 1, 0, 0, 0, 1);
    },
    toString: function(a) {
      var c = [];
      this.toArray(a, c);
      return c.join(' ');
    },
    toArray: function(a, c) {
      var f = this.elements,
        e = !!c,
        d = parseFloat(f[0].toFixed(3)),
        h = parseFloat(f[1].toFixed(3)),
        s = parseFloat(f[2].toFixed(3)),
        k = parseFloat(f[3].toFixed(3)),
        m = parseFloat(f[4].toFixed(3)),
        n = parseFloat(f[5].toFixed(3));
      if (a) {
        var g = parseFloat(f[6].toFixed(3)),
          j = parseFloat(f[7].toFixed(3)),
          f = parseFloat(f[8].toFixed(3));
        if (e) {
          c[0] = d;
          c[1] = k;
          c[2] = g;
          c[3] = h;
          c[4] = m;
          c[5] = j;
          c[6] = s;
          c[7] = n;
          c[8] = f;
          return;
        }
        return [d, k, g, h, m, j, s, n, f];
      }
      if (e) (c[0] = d), (c[1] = k), (c[2] = h), (c[3] = m), (c[4] = s), (c[5] = n);
      else return [d, k, h, m, s, n];
    },
    clone: function() {
      return new e.Matrix(
        this.elements[0],
        this.elements[1],
        this.elements[2],
        this.elements[3],
        this.elements[4],
        this.elements[5],
        this.elements[6],
        this.elements[7],
        this.elements[8],
      );
    },
  });
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h, p) {
  var n = e.Utils.mod,
    r = e.Utils.toFixed,
    k = {
      version: 1.1,
      ns: 'http://www.w3.org/2000/svg',
      xlink: 'http://www.w3.org/1999/xlink',
      alignments: { left: 'start', center: 'middle', right: 'end' },
      createElement: function(a, c) {
        var f = document.createElementNS(this.ns, a);
        'svg' === a && (c = h.defaults(c || {}, { version: this.version }));
        h.isEmpty(c) || k.setAttributes(f, c);
        return f;
      },
      setAttributes: function(a, c) {
        for (var f = Object.keys(c), e = 0; e < f.length; e++) a.setAttribute(f[e], c[f[e]]);
        return this;
      },
      removeAttributes: function(a, c) {
        for (var f in c) a.removeAttribute(f);
        return this;
      },
      toString: function(a, c) {
        for (var f = a.length, l = f - 1, d, h = '', s = 0; s < f; s++) {
          var k = a[s],
            m,
            u = c ? n(s - 1, f) : Math.max(s - 1, 0),
            g = c ? n(s + 1, f) : Math.min(s + 1, l);
          m = a[u];
          var j = a[g],
            x,
            p,
            v,
            u = r(k._x),
            j = r(k._y);
          switch (k._command) {
            case e.Commands.close:
              m = e.Commands.close;
              break;
            case e.Commands.curve:
              x = (m.controls && m.controls.right) || m;
              v = (k.controls && k.controls.left) || k;
              m._relative ? ((g = r(x.x + m.x)), (x = r(x.y + m.y))) : ((g = r(x.x)), (x = r(x.y)));
              k._relative ? ((p = r(v.x + k.x)), (v = r(v.y + k.y))) : ((p = r(v.x)), (v = r(v.y)));
              m =
                (0 === s ? e.Commands.move : e.Commands.curve) +
                ' ' +
                g +
                ' ' +
                x +
                ' ' +
                p +
                ' ' +
                v +
                ' ' +
                u +
                ' ' +
                j;
              break;
            case e.Commands.move:
              d = k;
              m = e.Commands.move + ' ' + u + ' ' + j;
              break;
            default:
              m = k._command + ' ' + u + ' ' + j;
          }
          s >= l &&
            c &&
            (k._command === e.Commands.curve &&
              ((j = d),
              (x = (k.controls && k.controls.right) || k),
              (u = (j.controls && j.controls.left) || j),
              k._relative ? ((g = r(x.x + k.x)), (x = r(x.y + k.y))) : ((g = r(x.x)), (x = r(x.y))),
              j._relative ? ((p = r(u.x + j.x)), (v = r(u.y + j.y))) : ((p = r(u.x)), (v = r(u.y))),
              (u = r(j.x)),
              (j = r(j.y)),
              (m += ' C ' + g + ' ' + x + ' ' + p + ' ' + v + ' ' + u + ' ' + j)),
            (m += ' Z'));
          h += m + ' ';
        }
        return h;
      },
      getClip: function(a) {
        var c = a._renderer.clip;
        if (!c) {
          for (var f = a; f.parent; ) f = f.parent;
          c = a._renderer.clip = k.createElement('clipPath');
          f.defs.appendChild(c);
        }
        return c;
      },
      group: {
        appendChild: function(a) {
          var c = a._renderer.elem;
          if (c) {
            var f = c.nodeName;
            f && (!/(radial|linear)gradient/i.test(f) && !a._clip) && this.elem.appendChild(c);
          }
        },
        removeChild: function(a) {
          var c = a._renderer.elem;
          c && c.parentNode == this.elem && c.nodeName && (a._clip || this.elem.removeChild(c));
        },
        orderChild: function(a) {
          this.elem.appendChild(a._renderer.elem);
        },
        renderChild: function(a) {
          k[a._renderer.type].render.call(a, this);
        },
        render: function(a) {
          this._update();
          if (0 === this._opacity && !this._flagOpacity) return this;
          this._renderer.elem ||
            ((this._renderer.elem = k.createElement('g', { id: this.id })), a.appendChild(this._renderer.elem));
          var c = { domElement: a, elem: this._renderer.elem };
          (this._matrix.manual || this._flagMatrix) &&
            this._renderer.elem.setAttribute('transform', 'matrix(' + this._matrix.toString() + ')');
          for (var f = 0; f < this.children.length; f++) {
            var e = this.children[f];
            k[e._renderer.type].render.call(e, a);
          }
          this._flagOpacity && this._renderer.elem.setAttribute('opacity', this._opacity);
          this._flagAdditions && this.additions.forEach(k.group.appendChild, c);
          this._flagSubtractions && this.subtractions.forEach(k.group.removeChild, c);
          this._flagOrder && this.children.forEach(k.group.orderChild, c);
          this._flagMask &&
            (this._mask
              ? this._renderer.elem.setAttribute('clip-path', 'url(#' + this._mask.id + ')')
              : this._renderer.elem.removeAttribute('clip-path'));
          return this.flagReset();
        },
      },
      path: {
        render: function(a) {
          this._update();
          if (0 === this._opacity && !this._flagOpacity) return this;
          var c = {};
          if (this._matrix.manual || this._flagMatrix) c.transform = 'matrix(' + this._matrix.toString() + ')';
          if (this._flagVertices) {
            var f = k.toString(this._vertices, this._closed);
            c.d = f;
          }
          this._flagFill &&
            (this._fill && this._fill._renderer && k[this._fill._renderer.type].render.call(this._fill, a),
            (c.fill = this._fill && this._fill.id ? 'url(#' + this._fill.id + ')' : this._fill));
          this._flagStroke &&
            (this._stroke && this._stroke._renderer && k[this._stroke._renderer.type].render.call(this._stroke, a),
            (c.stroke = this._stroke && this._stroke.id ? 'url(#' + this._stroke.id + ')' : this._stroke));
          this._flagLinewidth && (c['stroke-width'] = this._linewidth);
          this._flagOpacity && ((c['stroke-opacity'] = this._opacity), (c['fill-opacity'] = this._opacity));
          this._flagVisible && (c.visibility = this._visible ? 'visible' : 'hidden');
          this._flagCap && (c['stroke-linecap'] = this._cap);
          this._flagJoin && (c['stroke-linejoin'] = this._join);
          this._flagMiter && (c['stroke-miterlimit'] = this._miter);
          this._renderer.elem
            ? k.setAttributes(this._renderer.elem, c)
            : ((c.id = this.id),
              (this._renderer.elem = k.createElement('path', c)),
              a.appendChild(this._renderer.elem));
          this._flagClip &&
            ((a = k.getClip(this)),
            (c = this._renderer.elem),
            this._clip
              ? (c.removeAttribute('id'), a.setAttribute('id', this.id), a.appendChild(c))
              : (a.removeAttribute('id'), c.setAttribute('id', this.id), this.parent._renderer.elem.appendChild(c)));
          return this.flagReset();
        },
      },
      text: {
        render: function(a) {
          this._update();
          var c = {};
          if (this._matrix.manual || this._flagMatrix) c.transform = 'matrix(' + this._matrix.toString() + ')';
          this._flagFamily && (c['font-family'] = this._family);
          this._flagSize && (c['font-size'] = this._size);
          this._flagLeading && (c['line-height'] = this._leading);
          this._flagAlignment && (c['text-anchor'] = k.alignments[this._alignment] || this._alignment);
          this._flagBaseline && (c['alignment-baseline'] = c['dominant-baseline'] = this._baseline);
          this._flagStyle && (c['font-style'] = this._style);
          this._flagWeight && (c['font-weight'] = this._weight);
          this._flagDecoration && (c['text-decoration'] = this._decoration);
          this._flagFill && (c.fill = this._fill && this._fill.id ? 'url(#' + this._fill.id + ')' : this._fill);
          this._flagStroke &&
            (c.stroke = this._stroke && this._stroke.id ? 'url(#' + this._stroke.id + ')' : this._stroke);
          this._flagLinewidth && (c['stroke-width'] = this._linewidth);
          this._flagOpacity && (c.opacity = this._opacity);
          this._flagVisible && (c.visibility = this._visible ? 'visible' : 'hidden');
          this._renderer.elem
            ? k.setAttributes(this._renderer.elem, c)
            : ((c.id = this.id),
              (this._renderer.elem = k.createElement('text', c)),
              a.defs.appendChild(this._renderer.elem));
          this._flagClip &&
            ((a = k.getClip(this)),
            (c = this._renderer.elem),
            this._clip
              ? (c.removeAttribute('id'), a.setAttribute('id', this.id), a.appendChild(c))
              : (a.removeAttribute('id'), c.setAttribute('id', this.id), this.parent._renderer.elem.appendChild(c)));
          this._flagValue && (this._renderer.elem.textContent = this._value);
          return this.flagReset();
        },
      },
      'linear-gradient': {
        render: function(a) {
          this._update();
          var c = {};
          this._flagEndPoints &&
            ((c.x1 = this.left._x), (c.y1 = this.left._y), (c.x2 = this.right._x), (c.y2 = this.right._y));
          this._flagSpread && (c.spreadMethod = this._spread);
          this._renderer.elem
            ? k.setAttributes(this._renderer.elem, c)
            : ((c.id = this.id),
              (c.gradientUnits = 'userSpaceOnUse'),
              (this._renderer.elem = k.createElement('linearGradient', c)),
              a.defs.appendChild(this._renderer.elem));
          if (this._flagStops)
            for (a = this._renderer.elem.childNodes.length = 0; a < this.stops.length; a++) {
              var c = this.stops[a],
                f = {};
              c._flagOffset && (f.offset = 100 * c._offset + '%');
              c._flagColor && (f['stop-color'] = c._color);
              c._flagOpacity && (f['stop-opacity'] = c._opacity);
              c._renderer.elem ? k.setAttributes(c._renderer.elem, f) : (c._renderer.elem = k.createElement('stop', f));
              this._renderer.elem.appendChild(c._renderer.elem);
              c.flagReset();
            }
          return this.flagReset();
        },
      },
      'radial-gradient': {
        render: function(a) {
          this._update();
          var c = {};
          this._flagCenter && ((c.cx = this.center._x), (c.cy = this.center._y));
          this._flagFocal && ((c.fx = this.focal._x), (c.fy = this.focal._y));
          this._flagRadius && (c.r = this._radius);
          this._flagSpread && (c.spreadMethod = this._spread);
          this._renderer.elem
            ? k.setAttributes(this._renderer.elem, c)
            : ((c.id = this.id),
              (c.gradientUnits = 'userSpaceOnUse'),
              (this._renderer.elem = k.createElement('radialGradient', c)),
              a.defs.appendChild(this._renderer.elem));
          if (this._flagStops)
            for (a = this._renderer.elem.childNodes.length = 0; a < this.stops.length; a++) {
              var c = this.stops[a],
                f = {};
              c._flagOffset && (f.offset = 100 * c._offset + '%');
              c._flagColor && (f['stop-color'] = c._color);
              c._flagOpacity && (f['stop-opacity'] = c._opacity);
              c._renderer.elem ? k.setAttributes(c._renderer.elem, f) : (c._renderer.elem = k.createElement('stop', f));
              this._renderer.elem.appendChild(c._renderer.elem);
              c.flagReset();
            }
          return this.flagReset();
        },
      },
    },
    m = (e[e.Types.svg] = function(a) {
      this.domElement = a.domElement || k.createElement('svg');
      this.scene = new e.Group();
      this.scene.parent = this;
      this.defs = k.createElement('defs');
      this.domElement.appendChild(this.defs);
      this.domElement.defs = this.defs;
      this.domElement.style.overflow = 'hidden';
    });
  h.extend(m, { Utils: k });
  h.extend(m.prototype, p.Events, {
    setSize: function(a, c) {
      this.width = a;
      this.height = c;
      k.setAttributes(this.domElement, { width: a, height: c });
      return this;
    },
    render: function() {
      k.group.render.call(this.scene, this.domElement);
      return this;
    },
  });
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h, p) {
  var n = e.Utils.mod,
    r = e.Utils.toFixed,
    k = e.Utils.getRatio,
    m = function(a) {
      return 1 == a[0] && 0 == a[3] && 0 == a[1] && 1 == a[4] && 0 == a[2] && 0 == a[5];
    },
    a = {
      isHidden: /(none|transparent)/i,
      alignments: { left: 'start', middle: 'center', right: 'end' },
      group: {
        renderChild: function(c) {
          a[c._renderer.type].render.call(c, this.ctx, !0, this.clip);
        },
        render: function(c) {
          this._update();
          var e = this._matrix.elements,
            d = this.parent;
          this._renderer.opacity = this._opacity * (d && d._renderer ? d._renderer.opacity : 1);
          var d = m(e),
            h = this._mask;
          this._renderer.context || (this._renderer.context = {});
          this._renderer.context.ctx = c;
          d || (c.save(), c.transform(e[0], e[3], e[1], e[4], e[2], e[5]));
          h && a[h._renderer.type].render.call(h, c, !0);
          for (e = 0; e < this.children.length; e++) (h = this.children[e]), a[h._renderer.type].render.call(h, c);
          d || c.restore();
          return this.flagReset();
        },
      },
      path: {
        render: function(c, l, d) {
          var t, s, k, y, u, g, j, p, w, v, z, E, A, C, F, G;
          this._update();
          t = this._matrix.elements;
          s = this._stroke;
          k = this._linewidth;
          y = this._fill;
          u = this._opacity * this.parent._renderer.opacity;
          g = this._visible;
          j = this._cap;
          p = this._join;
          w = this._miter;
          v = this._closed;
          z = this._vertices;
          E = z.length;
          A = E - 1;
          G = m(t);
          F = this._clip;
          if (!l && (!g || F)) return this;
          G || (c.save(), c.transform(t[0], t[3], t[1], t[4], t[2], t[5]));
          y &&
            (h.isString(y)
              ? (c.fillStyle = y)
              : (a[y._renderer.type].render.call(y, c), (c.fillStyle = y._renderer.gradient)));
          s &&
            (h.isString(s)
              ? (c.strokeStyle = s)
              : (a[s._renderer.type].render.call(s, c), (c.strokeStyle = s._renderer.gradient)));
          k && (c.lineWidth = k);
          w && (c.miterLimit = w);
          p && (c.lineJoin = p);
          j && (c.lineCap = j);
          h.isNumber(u) && (c.globalAlpha = u);
          c.beginPath();
          for (t = 0; t < z.length; t++)
            switch (((l = z[t]), (u = r(l._x)), (g = r(l._y)), l._command)) {
              case e.Commands.close:
                c.closePath();
                break;
              case e.Commands.curve:
                k = v ? n(t - 1, E) : Math.max(t - 1, 0);
                v ? n(t + 1, E) : Math.min(t + 1, A);
                j = z[k];
                p = (j.controls && j.controls.right) || j;
                w = (l.controls && l.controls.left) || l;
                j._relative ? ((k = p.x + r(j._x)), (p = p.y + r(j._y))) : ((k = r(p.x)), (p = r(p.y)));
                l._relative ? ((j = w.x + r(l._x)), (w = w.y + r(l._y))) : ((j = r(w.x)), (w = r(w.y)));
                c.bezierCurveTo(k, p, j, w, u, g);
                t >= A &&
                  v &&
                  ((g = C),
                  (j = (l.controls && l.controls.right) || l),
                  (u = (g.controls && g.controls.left) || g),
                  l._relative ? ((k = j.x + r(l._x)), (p = j.y + r(l._y))) : ((k = r(j.x)), (p = r(j.y))),
                  g._relative ? ((j = u.x + r(g._x)), (w = u.y + r(g._y))) : ((j = r(u.x)), (w = r(u.y))),
                  (u = r(g._x)),
                  (g = r(g._y)),
                  c.bezierCurveTo(k, p, j, w, u, g));
                break;
              case e.Commands.line:
                c.lineTo(u, g);
                break;
              case e.Commands.move:
                (C = l), c.moveTo(u, g);
            }
          v && c.closePath();
          !F && !d && (a.isHidden.test(y) || c.fill(), a.isHidden.test(s) || c.stroke());
          G || c.restore();
          F && !d && c.clip();
          return this.flagReset();
        },
      },
      'linear-gradient': {
        render: function(a) {
          this._update();
          if (!this._renderer.gradient || this._flagEndPoints || this._flagStops) {
            this._renderer.gradient = a.createLinearGradient(this.left._x, this.left._y, this.right._x, this.right._y);
            for (a = 0; a < this.stops.length; a++) {
              var c = this.stops[a];
              this._renderer.gradient.addColorStop(c._offset, c._color);
            }
          }
          return this.flagReset();
        },
      },
      text: {
        render: function(c, e, d) {
          this._update();
          var t = this._matrix.elements,
            s = this._stroke,
            k = this._linewidth,
            n = this._fill,
            r = this._opacity * this.parent._renderer.opacity,
            g = this._visible,
            j = m(t),
            p = this._clip;
          if (!e && (!g || p)) return this;
          j || (c.save(), c.transform(t[0], t[3], t[1], t[4], t[2], t[5]));
          c.font = [this._style, this._weight, this._size + 'px/' + this._leading + 'px', this._family].join(' ');
          c.textAlign = a.alignments[this._alignment] || this._alignment;
          c.textBaseline = this._baseline;
          n &&
            (h.isString(n)
              ? (c.fillStyle = n)
              : (a[n._renderer.type].render.call(n, c), (c.fillStyle = n._renderer.gradient)));
          s &&
            (h.isString(s)
              ? (c.strokeStyle = s)
              : (a[s._renderer.type].render.call(s, c), (c.strokeStyle = s._renderer.gradient)));
          k && (c.lineWidth = k);
          h.isNumber(r) && (c.globalAlpha = r);
          !p &&
            !d &&
            (a.isHidden.test(n) || c.fillText(this.value, 0, 0), a.isHidden.test(s) || c.strokeText(this.value, 0, 0));
          j || c.restore();
          p && !d && c.clip();
          return this.flagReset();
        },
      },
      'radial-gradient': {
        render: function(a) {
          this._update();
          if (!this._renderer.gradient || this._flagCenter || this._flagFocal || this._flagRadius || this._flagStops) {
            this._renderer.gradient = a.createRadialGradient(
              this.center._x,
              this.center._y,
              0,
              this.focal._x,
              this.focal._y,
              this._radius,
            );
            for (a = 0; a < this.stops.length; a++) {
              var c = this.stops[a];
              this._renderer.gradient.addColorStop(c._offset, c._color);
            }
          }
          return this.flagReset();
        },
      },
    },
    c = (e[e.Types.canvas] = function(a) {
      var c = !1 !== a.smoothing;
      this.domElement = a.domElement || document.createElement('canvas');
      this.ctx = this.domElement.getContext('2d');
      this.overdraw = a.overdraw || !1;
      this.ctx.imageSmoothingEnabled = c;
      this.ctx.mozImageSmoothingEnabled = c;
      this.ctx.oImageSmoothingEnabled = c;
      this.ctx.webkitImageSmoothingEnabled = c;
      this.ctx.imageSmoothingEnabled = c;
      this.scene = new e.Group();
      this.scene.parent = this;
    });
  h.extend(c, { Utils: a });
  h.extend(c.prototype, p.Events, {
    setSize: function(a, c, d) {
      this.width = a;
      this.height = c;
      this.ratio = h.isUndefined(d) ? k(this.ctx) : d;
      this.domElement.width = a * this.ratio;
      this.domElement.height = c * this.ratio;
      h.extend(this.domElement.style, { width: a + 'px', height: c + 'px' });
      return this;
    },
    render: function() {
      var c = 1 === this.ratio;
      c || (this.ctx.save(), this.ctx.scale(this.ratio, this.ratio));
      this.overdraw || this.ctx.clearRect(0, 0, this.width, this.height);
      a.group.render.call(this.scene, this.ctx);
      c || this.ctx.restore();
      return this;
    },
  });
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h, p) {
  var n = e.Matrix.Multiply,
    r = e.Utils.mod,
    k = [1, 0, 0, 0, 1, 0, 0, 0, 1],
    m = new e.Array(9),
    a = e.Utils.getRatio,
    c = e.Utils.toFixed,
    f = {
      isHidden: /(none|transparent)/i,
      canvas: document.createElement('canvas'),
      alignments: { left: 'start', middle: 'center', right: 'end' },
      matrix: new e.Matrix(),
      uv: new e.Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]),
      group: {
        removeChild: function(a, c) {
          if (a.children) for (var e = 0; e < a.children.length; e++) f.group.removeChild(a.children[e], c);
          else c.deleteTexture(a._renderer.texture), delete a._renderer.texture;
        },
        renderChild: function(a) {
          f[a._renderer.type].render.call(a, this.gl, this.program);
        },
        render: function(a, c) {
          this._update();
          var h = this.parent,
            l = (h._matrix && h._matrix.manual) || h._flagMatrix,
            k = this._matrix.manual || this._flagMatrix;
          if (l || k)
            this._renderer.matrix || (this._renderer.matrix = new e.Array(9)),
              this._matrix.toArray(!0, m),
              n(m, h._renderer.matrix, this._renderer.matrix),
              (this._renderer.scale = this._scale * h._renderer.scale),
              l && (this._flagMatrix = !0);
          this._mask &&
            (a.enable(a.STENCIL_TEST),
            a.stencilFunc(a.ALWAYS, 1, 1),
            a.colorMask(!1, !1, !1, !0),
            a.stencilOp(a.KEEP, a.KEEP, a.INCR),
            f[this._mask._renderer.type].render.call(this._mask, a, c, this),
            a.colorMask(!0, !0, !0, !0),
            a.stencilFunc(a.NOTEQUAL, 0, 1),
            a.stencilOp(a.KEEP, a.KEEP, a.KEEP));
          this._flagOpacity = h._flagOpacity || this._flagOpacity;
          this._renderer.opacity = this._opacity * (h && h._renderer ? h._renderer.opacity : 1);
          if (this._flagSubtractions)
            for (h = 0; h < this.subtractions.length; h++) f.group.removeChild(this.subtractions[h], a);
          this.children.forEach(f.group.renderChild, { gl: a, program: c });
          this._mask &&
            (a.colorMask(!1, !1, !1, !1),
            a.stencilOp(a.KEEP, a.KEEP, a.DECR),
            f[this._mask._renderer.type].render.call(this._mask, a, c, this),
            a.colorMask(!0, !0, !0, !0),
            a.stencilFunc(a.NOTEQUAL, 0, 1),
            a.stencilOp(a.KEEP, a.KEEP, a.KEEP),
            a.disable(a.STENCIL_TEST));
          return this.flagReset();
        },
      },
      path: {
        updateCanvas: function(a) {
          var l,
            s,
            k,
            m,
            n,
            g,
            j = a._vertices;
          l = this.canvas;
          var p = this.ctx;
          g = a._renderer.scale;
          var w = a._stroke;
          k = a._linewidth;
          var v = a._fill;
          s = a._renderer.opacity || a._opacity;
          n = a._cap;
          m = a._join;
          var z = a._miter,
            E = a._closed,
            A = j.length,
            C = A - 1;
          l.width = Math.max(Math.ceil(a._renderer.rect.width * g), 1);
          l.height = Math.max(Math.ceil(a._renderer.rect.height * g), 1);
          var F = a._renderer.rect.centroid,
            G = F.x,
            F = F.y;
          p.clearRect(0, 0, l.width, l.height);
          v &&
            (h.isString(v)
              ? (p.fillStyle = v)
              : (f[v._renderer.type].render.call(v, p, a), (p.fillStyle = v._renderer.gradient)));
          w &&
            (h.isString(w)
              ? (p.strokeStyle = w)
              : (f[w._renderer.type].render.call(w, p, a), (p.strokeStyle = w._renderer.gradient)));
          k && (p.lineWidth = k);
          z && (p.miterLimit = z);
          m && (p.lineJoin = m);
          n && (p.lineCap = n);
          h.isNumber(s) && (p.globalAlpha = s);
          var q;
          p.save();
          p.scale(g, g);
          p.translate(G, F);
          p.beginPath();
          for (a = 0; a < j.length; a++)
            switch (((b = j[a]), (g = c(b._x)), (k = c(b._y)), b._command)) {
              case e.Commands.close:
                p.closePath();
                break;
              case e.Commands.curve:
                l = E ? r(a - 1, A) : Math.max(a - 1, 0);
                E ? r(a + 1, A) : Math.min(a + 1, C);
                s = j[l];
                n = (s.controls && s.controls.right) || s;
                m = (b.controls && b.controls.left) || b;
                s._relative ? ((l = c(n.x + s._x)), (n = c(n.y + s._y))) : ((l = c(n.x)), (n = c(n.y)));
                b._relative ? ((s = c(m.x + b._x)), (m = c(m.y + b._y))) : ((s = c(m.x)), (m = c(m.y)));
                p.bezierCurveTo(l, n, s, m, g, k);
                a >= C &&
                  E &&
                  ((k = q),
                  (s = (b.controls && b.controls.right) || b),
                  (g = (k.controls && k.controls.left) || k),
                  b._relative ? ((l = c(s.x + b._x)), (n = c(s.y + b._y))) : ((l = c(s.x)), (n = c(s.y))),
                  k._relative ? ((s = c(g.x + k._x)), (m = c(g.y + k._y))) : ((s = c(g.x)), (m = c(g.y))),
                  (g = c(k._x)),
                  (k = c(k._y)),
                  p.bezierCurveTo(l, n, s, m, g, k));
                break;
              case e.Commands.line:
                p.lineTo(g, k);
                break;
              case e.Commands.move:
                (q = b), p.moveTo(g, k);
            }
          E && p.closePath();
          f.isHidden.test(v) || p.fill();
          f.isHidden.test(w) || p.stroke();
          p.restore();
        },
        getBoundingClientRect: function(a, c, f) {
          var e = Infinity,
            l = -Infinity,
            k = Infinity,
            g = -Infinity;
          a.forEach(function(a) {
            var c = a.x,
              d = a.y,
              f = a.controls,
              h,
              s;
            k = Math.min(d, k);
            e = Math.min(c, e);
            l = Math.max(c, l);
            g = Math.max(d, g);
            a.controls &&
              ((h = f.left),
              (s = f.right),
              h &&
                s &&
                ((f = a._relative ? h.x + c : h.x),
                (h = a._relative ? h.y + d : h.y),
                (c = a._relative ? s.x + c : s.x),
                (a = a._relative ? s.y + d : s.y),
                f &&
                  (h && c && a) &&
                  ((k = Math.min(h, a, k)),
                  (e = Math.min(f, c, e)),
                  (l = Math.max(f, c, l)),
                  (g = Math.max(h, a, g)))));
          });
          h.isNumber(c) && ((k -= c), (e -= c), (l += c), (g += c));
          f.top = k;
          f.left = e;
          f.right = l;
          f.bottom = g;
          f.width = l - e;
          f.height = g - k;
          f.centroid || (f.centroid = {});
          f.centroid.x = -e;
          f.centroid.y = -k;
        },
        render: function(a, c, h) {
          if (!this._visible || !this._opacity) return this;
          var l = this.parent,
            k = l._matrix.manual || l._flagMatrix,
            r = this._matrix.manual || this._flagMatrix,
            g =
              this._flagVertices ||
              this._flagFill ||
              (this._fill instanceof e.LinearGradient &&
                (this._fill._flagSpread || this._fill._flagStops || this._fill._flagEndPoints)) ||
              (this._fill instanceof e.RadialGradient &&
                (this._fill._flagSpread ||
                  this._fill._flagStops ||
                  this._fill._flagRadius ||
                  this._fill._flagCenter ||
                  this._fill._flagFocal)) ||
              (this._stroke instanceof e.LinearGradient &&
                (this._stroke._flagSpread || this._stroke._flagStops || this._stroke._flagEndPoints)) ||
              (this._stroke instanceof e.RadialGradient &&
                (this._stroke._flagSpread ||
                  this._stroke._flagStops ||
                  this._stroke._flagRadius ||
                  this._stroke._flagCenter ||
                  this._stroke._flagFocal)) ||
              this._flagStroke ||
              this._flagLinewidth ||
              this._flagOpacity ||
              l._flagOpacity ||
              this._flagVisible ||
              this._flagCap ||
              this._flagJoin ||
              this._flagMiter ||
              this._flagScale ||
              !this._renderer.texture;
          this._update();
          if (k || r)
            this._renderer.matrix || (this._renderer.matrix = new e.Array(9)),
              this._matrix.toArray(!0, m),
              n(m, l._renderer.matrix, this._renderer.matrix),
              (this._renderer.scale = this._scale * l._renderer.scale);
          g &&
            (this._renderer.rect || (this._renderer.rect = {}),
            this._renderer.triangles || (this._renderer.triangles = new e.Array(12)),
            (this._renderer.opacity = this._opacity * l._renderer.opacity),
            f.path.getBoundingClientRect(this._vertices, this._linewidth, this._renderer.rect),
            f.getTriangles(this._renderer.rect, this._renderer.triangles),
            f.updateBuffer.call(f, a, this, c),
            f.updateTexture.call(f, a, this));
          if (!this._clip || h)
            return (
              a.bindBuffer(a.ARRAY_BUFFER, this._renderer.textureCoordsBuffer),
              a.vertexAttribPointer(c.textureCoords, 2, a.FLOAT, !1, 0, 0),
              a.bindTexture(a.TEXTURE_2D, this._renderer.texture),
              a.uniformMatrix3fv(c.matrix, !1, this._renderer.matrix),
              a.bindBuffer(a.ARRAY_BUFFER, this._renderer.buffer),
              a.vertexAttribPointer(c.position, 2, a.FLOAT, !1, 0, 0),
              a.drawArrays(a.TRIANGLES, 0, 6),
              this.flagReset()
            );
        },
      },
      text: {
        updateCanvas: function(a) {
          var c = this.canvas,
            e = this.ctx,
            l = a._renderer.scale,
            k = a._stroke,
            m = a._linewidth * l,
            g = a._fill,
            j = a._renderer.opacity || a._opacity;
          c.width = Math.max(Math.ceil(a._renderer.rect.width * l), 1);
          c.height = Math.max(Math.ceil(a._renderer.rect.height * l), 1);
          var n = a._renderer.rect.centroid,
            r = n.x,
            n = n.y;
          e.clearRect(0, 0, c.width, c.height);
          e.font = [a._style, a._weight, a._size + 'px/' + a._leading + 'px', a._family].join(' ');
          e.textAlign = 'center';
          e.textBaseline = 'middle';
          g &&
            (h.isString(g)
              ? (e.fillStyle = g)
              : (f[g._renderer.type].render.call(g, e, a), (e.fillStyle = g._renderer.gradient)));
          k &&
            (h.isString(k)
              ? (e.strokeStyle = k)
              : (f[k._renderer.type].render.call(k, e, a), (e.strokeStyle = k._renderer.gradient)));
          m && (e.lineWidth = m);
          h.isNumber(j) && (e.globalAlpha = j);
          e.save();
          e.scale(l, l);
          e.translate(r, n);
          f.isHidden.test(g) || e.fillText(a.value, 0, 0);
          f.isHidden.test(k) || e.strokeText(a.value, 0, 0);
          e.restore();
        },
        getBoundingClientRect: function(a, c) {
          var e = f.ctx;
          e.font = [a._style, a._weight, a._size + 'px/' + a._leading + 'px', a._family].join(' ');
          e.textAlign = 'center';
          e.textBaseline = a._baseline;
          var e = e.measureText(a._value).width,
            h = Math.max(a._size || a._leading);
          this._linewidth && !f.isHidden.test(this._stroke) && (h += this._linewidth);
          var l = e / 2,
            k = h / 2;
          switch (f.alignments[a._alignment] || a._alignment) {
            case f.alignments.left:
              c.left = 0;
              c.right = e;
              break;
            case f.alignments.right:
              c.left = -e;
              c.right = 0;
              break;
            default:
              (c.left = -l), (c.right = l);
          }
          switch (a._baseline) {
            case 'bottom':
              c.top = -h;
              c.bottom = 0;
              break;
            case 'top':
              c.top = 0;
              c.bottom = h;
              break;
            default:
              (c.top = -k), (c.bottom = k);
          }
          c.width = e;
          c.height = h;
          c.centroid || (c.centroid = {});
          c.centroid.x = l;
          c.centroid.y = k;
        },
        render: function(a, c, h) {
          if (!this._visible || !this._opacity) return this;
          var l = this.parent,
            k = l._matrix.manual || l._flagMatrix,
            r = this._matrix.manual || this._flagMatrix,
            g =
              this._flagVertices ||
              this._flagFill ||
              (this._fill instanceof e.LinearGradient &&
                (this._fill._flagSpread || this._fill._flagStops || this._fill._flagEndPoints)) ||
              (this._fill instanceof e.RadialGradient &&
                (this._fill._flagSpread ||
                  this._fill._flagStops ||
                  this._fill._flagRadius ||
                  this._fill._flagCenter ||
                  this._fill._flagFocal)) ||
              (this._stroke instanceof e.LinearGradient &&
                (this._stroke._flagSpread || this._stroke._flagStops || this._stroke._flagEndPoints)) ||
              (this._stroke instanceof e.RadialGradient &&
                (this._stroke._flagSpread ||
                  this._stroke._flagStops ||
                  this._stroke._flagRadius ||
                  this._stroke._flagCenter ||
                  this._stroke._flagFocal)) ||
              this._flagStroke ||
              this._flagLinewidth ||
              this._flagOpacity ||
              l._flagOpacity ||
              this._flagVisible ||
              this._flagScale ||
              this._flagValue ||
              this._flagFamily ||
              this._flagSize ||
              this._flagLeading ||
              this._flagAlignment ||
              this._flagBaseline ||
              this._flagStyle ||
              this._flagWeight ||
              this._flagDecoration ||
              !this._renderer.texture;
          this._update();
          if (k || r)
            this._renderer.matrix || (this._renderer.matrix = new e.Array(9)),
              this._matrix.toArray(!0, m),
              n(m, l._renderer.matrix, this._renderer.matrix),
              (this._renderer.scale = this._scale * l._renderer.scale);
          g &&
            (this._renderer.rect || (this._renderer.rect = {}),
            this._renderer.triangles || (this._renderer.triangles = new e.Array(12)),
            (this._renderer.opacity = this._opacity * l._renderer.opacity),
            f.text.getBoundingClientRect(this, this._renderer.rect),
            f.getTriangles(this._renderer.rect, this._renderer.triangles),
            f.updateBuffer.call(f, a, this, c),
            f.updateTexture.call(f, a, this));
          if (!this._clip || h)
            return (
              a.bindBuffer(a.ARRAY_BUFFER, this._renderer.textureCoordsBuffer),
              a.vertexAttribPointer(c.textureCoords, 2, a.FLOAT, !1, 0, 0),
              a.bindTexture(a.TEXTURE_2D, this._renderer.texture),
              a.uniformMatrix3fv(c.matrix, !1, this._renderer.matrix),
              a.bindBuffer(a.ARRAY_BUFFER, this._renderer.buffer),
              a.vertexAttribPointer(c.position, 2, a.FLOAT, !1, 0, 0),
              a.drawArrays(a.TRIANGLES, 0, 6),
              this.flagReset()
            );
        },
      },
      'linear-gradient': {
        render: function(a) {
          if (a.canvas.getContext('2d')) {
            this._update();
            if (!this._renderer.gradient || this._flagEndPoints || this._flagStops) {
              this._renderer.gradient = a.createLinearGradient(
                this.left._x,
                this.left._y,
                this.right._x,
                this.right._y,
              );
              for (a = 0; a < this.stops.length; a++) {
                var c = this.stops[a];
                this._renderer.gradient.addColorStop(c._offset, c._color);
              }
            }
            return this.flagReset();
          }
        },
      },
      'radial-gradient': {
        render: function(a) {
          if (a.canvas.getContext('2d')) {
            this._update();
            if (
              !this._renderer.gradient ||
              this._flagCenter ||
              this._flagFocal ||
              this._flagRadius ||
              this._flagStops
            ) {
              this._renderer.gradient = a.createRadialGradient(
                this.center._x,
                this.center._y,
                0,
                this.focal._x,
                this.focal._y,
                this._radius,
              );
              for (a = 0; a < this.stops.length; a++) {
                var c = this.stops[a];
                this._renderer.gradient.addColorStop(c._offset, c._color);
              }
            }
            return this.flagReset();
          }
        },
      },
      getTriangles: function(a, c) {
        var f = a.top,
          e = a.left,
          h = a.right,
          l = a.bottom;
        c[0] = e;
        c[1] = f;
        c[2] = h;
        c[3] = f;
        c[4] = e;
        c[5] = l;
        c[6] = e;
        c[7] = l;
        c[8] = h;
        c[9] = f;
        c[10] = h;
        c[11] = l;
      },
      updateTexture: function(a, c) {
        this[c._renderer.type].updateCanvas.call(f, c);
        c._renderer.texture && a.deleteTexture(c._renderer.texture);
        a.bindBuffer(a.ARRAY_BUFFER, c._renderer.textureCoordsBuffer);
        c._renderer.texture = a.createTexture();
        a.bindTexture(a.TEXTURE_2D, c._renderer.texture);
        a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE);
        a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE);
        a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.LINEAR);
        0 >= this.canvas.width ||
          0 >= this.canvas.height ||
          a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, this.canvas);
      },
      updateBuffer: function(a, c, f) {
        h.isObject(c._renderer.buffer) && a.deleteBuffer(c._renderer.buffer);
        c._renderer.buffer = a.createBuffer();
        a.bindBuffer(a.ARRAY_BUFFER, c._renderer.buffer);
        a.enableVertexAttribArray(f.position);
        a.bufferData(a.ARRAY_BUFFER, c._renderer.triangles, a.STATIC_DRAW);
        h.isObject(c._renderer.textureCoordsBuffer) && a.deleteBuffer(c._renderer.textureCoordsBuffer);
        c._renderer.textureCoordsBuffer = a.createBuffer();
        a.bindBuffer(a.ARRAY_BUFFER, c._renderer.textureCoordsBuffer);
        a.enableVertexAttribArray(f.textureCoords);
        a.bufferData(a.ARRAY_BUFFER, this.uv, a.STATIC_DRAW);
      },
      program: {
        create: function(a, c) {
          var f, l;
          f = a.createProgram();
          h.each(c, function(c) {
            a.attachShader(f, c);
          });
          a.linkProgram(f);
          if (!a.getProgramParameter(f, a.LINK_STATUS))
            throw ((l = a.getProgramInfoLog(f)), a.deleteProgram(f), new e.Utils.Error('unable to link program: ' + l));
          return f;
        },
      },
      shaders: {
        create: function(a, c, f) {
          f = a.createShader(a[f]);
          a.shaderSource(f, c);
          a.compileShader(f);
          if (!a.getShaderParameter(f, a.COMPILE_STATUS))
            throw ((c = a.getShaderInfoLog(f)),
            a.deleteShader(f),
            new e.Utils.Error('unable to compile shader ' + f + ': ' + c));
          return f;
        },
        types: { vertex: 'VERTEX_SHADER', fragment: 'FRAGMENT_SHADER' },
        vertex:
          'attribute vec2 a_position;\nattribute vec2 a_textureCoords;\n\nuniform mat3 u_matrix;\nuniform vec2 u_resolution;\n\nvarying vec2 v_textureCoords;\n\nvoid main() {\n   vec2 projected = (u_matrix * vec3(a_position, 1.0)).xy;\n   vec2 normal = projected / u_resolution;\n   vec2 clipspace = (normal * 2.0) - 1.0;\n\n   gl_Position = vec4(clipspace * vec2(1.0, -1.0), 0.0, 1.0);\n   v_textureCoords = a_textureCoords;\n}',
        fragment:
          'precision mediump float;\n\nuniform sampler2D u_image;\nvarying vec2 v_textureCoords;\n\nvoid main() {\n  gl_FragColor = texture2D(u_image, v_textureCoords);\n}',
      },
    };
  f.ctx = f.canvas.getContext('2d');
  var l = (e[e.Types.webgl] = function(a) {
    var c, l;
    this.domElement = a.domElement || document.createElement('canvas');
    this.scene = new e.Group();
    this.scene.parent = this;
    this._renderer = { matrix: new e.Array(k), scale: 1, opacity: 1 };
    this._flagMatrix = !0;
    a = h.defaults(a || {}, {
      antialias: !1,
      alpha: !0,
      premultipliedAlpha: !0,
      stencil: !0,
      preserveDrawingBuffer: !0,
      overdraw: !1,
    });
    this.overdraw = a.overdraw;
    a = this.ctx = this.domElement.getContext('webgl', a) || this.domElement.getContext('experimental-webgl', a);
    if (!this.ctx) throw new e.Utils.Error('unable to create a webgl context. Try using another renderer.');
    c = f.shaders.create(a, f.shaders.vertex, f.shaders.types.vertex);
    l = f.shaders.create(a, f.shaders.fragment, f.shaders.types.fragment);
    this.program = f.program.create(a, [c, l]);
    a.useProgram(this.program);
    this.program.position = a.getAttribLocation(this.program, 'a_position');
    this.program.matrix = a.getUniformLocation(this.program, 'u_matrix');
    this.program.textureCoords = a.getAttribLocation(this.program, 'a_textureCoords');
    a.disable(a.DEPTH_TEST);
    a.enable(a.BLEND);
    a.blendEquationSeparate(a.FUNC_ADD, a.FUNC_ADD);
    a.blendFuncSeparate(a.SRC_ALPHA, a.ONE_MINUS_SRC_ALPHA, a.ONE, a.ONE_MINUS_SRC_ALPHA);
  });
  h.extend(l.prototype, p.Events, {
    setSize: function(c, f, e) {
      this.width = c;
      this.height = f;
      this.ratio = h.isUndefined(e) ? a(this.ctx) : e;
      this.domElement.width = c * this.ratio;
      this.domElement.height = f * this.ratio;
      h.extend(this.domElement.style, { width: c + 'px', height: f + 'px' });
      c *= this.ratio;
      f *= this.ratio;
      this._renderer.matrix[0] = this._renderer.matrix[4] = this._renderer.scale = this.ratio;
      this._flagMatrix = !0;
      this.ctx.viewport(0, 0, c, f);
      e = this.ctx.getUniformLocation(this.program, 'u_resolution');
      this.ctx.uniform2f(e, c, f);
      return this;
    },
    render: function() {
      var a = this.ctx;
      this.overdraw || a.clear(a.COLOR_BUFFER_BIT | a.DEPTH_BUFFER_BIT);
      f.group.render.call(this.scene, a, this.program);
      this._flagMatrix = !1;
      return this;
    },
  });
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h, p) {
  var n = (e.Shape = function() {
    this._renderer = {};
    this.id = e.Identifier + e.uniqueId();
    this.classList = [];
    this._matrix = new e.Matrix();
    this.translation = new e.Vector();
    this.translation.bind(e.Events.change, h.bind(n.FlagMatrix, this));
    this.rotation = 0;
    this.scale = 1;
  });
  h.extend(n, p.Events, {
    FlagMatrix: function() {
      this._flagMatrix = !0;
    },
    MakeObservable: function(e) {
      Object.defineProperty(e, 'rotation', {
        get: function() {
          return this._rotation;
        },
        set: function(e) {
          this._rotation = e;
          this._flagMatrix = !0;
        },
      });
      Object.defineProperty(e, 'scale', {
        get: function() {
          return this._scale;
        },
        set: function(e) {
          this._scale = e;
          this._flagScale = this._flagMatrix = !0;
        },
      });
    },
  });
  h.extend(n.prototype, {
    _flagMatrix: !0,
    _rotation: 0,
    _scale: 1,
    addTo: function(e) {
      e.add(this);
      return this;
    },
    clone: function() {
      var e = new n();
      e.translation.copy(this.translation);
      e.rotation = this.rotation;
      e.scale = this.scale;
      h.each(
        n.Properties,
        function(h) {
          e[h] = this[h];
        },
        this,
      );
      return e._update();
    },
    _update: function(e) {
      !this._matrix.manual &&
        this._flagMatrix &&
        this._matrix
          .identity()
          .translate(this.translation.x, this.translation.y)
          .scale(this.scale)
          .rotate(this.rotation);
      e && this.parent && this.parent._update && this.parent._update();
      return this;
    },
    flagReset: function() {
      this._flagMatrix = this._flagScale = !1;
      return this;
    },
  });
  n.MakeObservable(n.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  function p(a, c, d) {
    var h,
      k,
      m,
      n,
      r,
      g,
      j,
      p,
      w = c.controls && c.controls.right,
      v = a.controls && a.controls.left;
    h = c.x;
    r = c.y;
    k = (w || c).x;
    g = (w || c).y;
    m = (v || a).x;
    j = (v || a).y;
    n = a.x;
    p = a.y;
    w && c._relative && ((k += c.x), (g += c.y));
    v && a._relative && ((m += a.x), (j += a.y));
    return e.Utils.getCurveLength(h, r, k, g, m, j, n, p, d);
  }
  function n(a, c, d) {
    var h,
      k,
      m,
      n,
      r,
      g,
      j,
      p,
      w = c.controls && c.controls.right,
      v = a.controls && a.controls.left;
    h = c.x;
    r = c.y;
    k = (w || c).x;
    g = (w || c).y;
    m = (v || a).x;
    j = (v || a).y;
    n = a.x;
    p = a.y;
    w && c._relative && ((k += c.x), (g += c.y));
    v && a._relative && ((m += a.x), (j += a.y));
    return e.Utils.subdivide(h, r, k, g, m, j, n, p, d);
  }
  var r = Math.min,
    k = Math.max,
    m = Math.round,
    a = e.Utils.getComputedMatrix;
  h.each(e.Commands, function() {});
  var c = (e.Path = function(a, c, d, h) {
    e.Shape.call(this);
    this._renderer.type = 'path';
    this._closed = !!c;
    this._curved = !!d;
    this.beginning = 0;
    this.ending = 1;
    this.fill = '#fff';
    this.stroke = '#000';
    this.opacity = this.linewidth = 1;
    this.visible = !0;
    this.cap = 'butt';
    this.join = 'miter';
    this.miter = 4;
    this._vertices = [];
    this.vertices = a;
    this.automatic = !h;
  });
  h.extend(c, {
    Properties: 'fill stroke linewidth opacity visible cap join miter closed curved automatic beginning ending'.split(
      ' ',
    ),
    FlagVertices: function() {
      this._flagLength = this._flagVertices = !0;
    },
    MakeObservable: function(a) {
      e.Shape.MakeObservable(a);
      h.each(c.Properties.slice(0, 8), function(c) {
        var d = '_' + c,
          e = '_flag' + c.charAt(0).toUpperCase() + c.slice(1);
        Object.defineProperty(a, c, {
          get: function() {
            return this[d];
          },
          set: function(a) {
            this[d] = a;
            this[e] = !0;
          },
        });
      });
      Object.defineProperty(a, 'length', {
        get: function() {
          this._flagLength && this._updateLength();
          return this._length;
        },
      });
      Object.defineProperty(a, 'closed', {
        get: function() {
          return this._closed;
        },
        set: function(a) {
          this._closed = !!a;
          this._flagVertices = !0;
        },
      });
      Object.defineProperty(a, 'curved', {
        get: function() {
          return this._curved;
        },
        set: function(a) {
          this._curved = !!a;
          this._flagVertices = !0;
        },
      });
      Object.defineProperty(a, 'automatic', {
        get: function() {
          return this._automatic;
        },
        set: function(a) {
          if (a !== this._automatic) {
            var c = (this._automatic = !!a) ? 'ignore' : 'listen';
            h.each(this.vertices, function(a) {
              a[c]();
            });
          }
        },
      });
      Object.defineProperty(a, 'beginning', {
        get: function() {
          return this._beginning;
        },
        set: function(a) {
          this._beginning = r(k(a, 0), this._ending);
          this._flagVertices = !0;
        },
      });
      Object.defineProperty(a, 'ending', {
        get: function() {
          return this._ending;
        },
        set: function(a) {
          this._ending = r(k(a, this._beginning), 1);
          this._flagVertices = !0;
        },
      });
      Object.defineProperty(a, 'vertices', {
        get: function() {
          return this._collection;
        },
        set: function(a) {
          var d = h.bind(c.FlagVertices, this),
            f = h.bind(function(a) {
              for (var c = a.length; c--; ) a[c].bind(e.Events.change, d);
              d();
            }, this),
            k = h.bind(function(a) {
              h.each(
                a,
                function(a) {
                  a.unbind(e.Events.change, d);
                },
                this,
              );
              d();
            }, this);
          this._collection && this._collection.unbind();
          this._collection = new e.Utils.Collection((a || []).slice(0));
          this._collection.bind(e.Events.insert, f);
          this._collection.bind(e.Events.remove, k);
          f(this._collection);
        },
      });
      Object.defineProperty(a, 'clip', {
        get: function() {
          return this._clip;
        },
        set: function(a) {
          this._clip = a;
          this._flagClip = !0;
        },
      });
    },
  });
  h.extend(c.prototype, e.Shape.prototype, {
    _flagVertices: !0,
    _flagLength: !0,
    _flagFill: !0,
    _flagStroke: !0,
    _flagLinewidth: !0,
    _flagOpacity: !0,
    _flagVisible: !0,
    _flagCap: !0,
    _flagJoin: !0,
    _flagMiter: !0,
    _flagClip: !1,
    _length: 0,
    _fill: '#fff',
    _stroke: '#000',
    _linewidth: 1,
    _opacity: 1,
    _visible: !0,
    _cap: 'round',
    _join: 'round',
    _miter: 4,
    _closed: !0,
    _curved: !1,
    _automatic: !0,
    _beginning: 0,
    _ending: 1,
    _clip: !1,
    clone: function(a) {
      a = a || this.parent;
      var l = h.map(this.vertices, function(a) {
          return a.clone();
        }),
        d = new c(l, this.closed, this.curved, !this.automatic);
      h.each(
        e.Path.Properties,
        function(a) {
          d[a] = this[a];
        },
        this,
      );
      d.translation.copy(this.translation);
      d.rotation = this.rotation;
      d.scale = this.scale;
      a.add(d);
      return d;
    },
    toObject: function() {
      var a = {
        vertices: h.map(this.vertices, function(a) {
          return a.toObject();
        }),
      };
      h.each(
        e.Shape.Properties,
        function(c) {
          a[c] = this[c];
        },
        this,
      );
      a.translation = this.translation.toObject;
      a.rotation = this.rotation;
      a.scale = this.scale;
      return a;
    },
    noFill: function() {
      this.fill = 'transparent';
      return this;
    },
    noStroke: function() {
      this.stroke = 'transparent';
      return this;
    },
    corner: function() {
      var a = this.getBoundingClientRect(!0);
      a.centroid = { x: a.left + a.width / 2, y: a.top + a.height / 2 };
      h.each(this.vertices, function(c) {
        c.addSelf(a.centroid);
      });
      return this;
    },
    center: function() {
      var a = this.getBoundingClientRect(!0);
      a.centroid = { x: a.left + a.width / 2, y: a.top + a.height / 2 };
      h.each(this.vertices, function(c) {
        c.subSelf(a.centroid);
      });
      return this;
    },
    remove: function() {
      if (!this.parent) return this;
      this.parent.remove(this);
      return this;
    },
    getBoundingClientRect: function(c) {
      var e,
        d,
        h,
        m,
        n,
        p = Infinity,
        u = -Infinity,
        g = Infinity,
        j = -Infinity;
      this._update(!0);
      c = c ? this._matrix : a(this);
      e = this.linewidth / 2;
      d = this._vertices.length;
      for (n = 0; n < d; n++)
        (m = this._vertices[n]),
          (h = m.x),
          (m = m.y),
          (m = c.multiply(h, m, 1)),
          (g = r(m.y - e, g)),
          (p = r(m.x - e, p)),
          (u = k(m.x + e, u)),
          (j = k(m.y + e, j));
      return { top: g, left: p, right: u, bottom: j, width: u - p, height: j - g };
    },
    getPointAt: function(a, c) {
      var d, k, m, n, p, r, g, j, x, w, v, z;
      g = this.length * Math.min(Math.max(a, 0), 1);
      j = this.vertices.length;
      x = j - 1;
      r = d = null;
      w = 0;
      k = this._lengths.length;
      for (m = 0; w < k; w++) {
        if (m + this._lengths[w] > g) {
          d = this.vertices[this.closed ? e.Utils.mod(w, j) : w];
          r = this.vertices[Math.min(Math.max(w - 1, 0), x)];
          g -= m;
          a = g / this._lengths[w];
          break;
        }
        m += this._lengths[w];
      }
      if (h.isNull(d) || h.isNull(r)) return null;
      z = r.controls && r.controls.right;
      v = d.controls && d.controls.left;
      k = r.x;
      g = r.y;
      m = (z || r).x;
      j = (z || r).y;
      n = (v || d).x;
      x = (v || d).y;
      p = d.x;
      w = d.y;
      z && r._relative && ((m += r.x), (j += r.y));
      v && d._relative && ((n += d.x), (x += d.y));
      d = e.Utils.getPointOnCubicBezier(a, k, m, n, p);
      r = e.Utils.getPointOnCubicBezier(a, g, j, x, w);
      return h.isObject(c) ? ((c.x = d), (c.y = r), c) : new e.Vector(d, r);
    },
    plot: function() {
      if (this.curved) return e.Utils.getCurveFromPoints(this._vertices, this.closed), this;
      for (var a = 0; a < this._vertices.length; a++)
        this._vertices[a]._command = 0 === a ? e.Commands.move : e.Commands.line;
      return this;
    },
    subdivide: function(a) {
      this._update();
      var c = this.vertices.length - 1,
        d = this.vertices[c],
        k = this._closed || this.vertices[c]._command === e.Commands.close,
        m = [];
      h.each(
        this.vertices,
        function(r, p) {
          if (!(0 >= p) || k)
            if (r.command === e.Commands.move)
              m.push(new e.Anchor(d.x, d.y)), 0 < p && (m[m.length - 1].command = e.Commands.line);
            else {
              var u = n(r, d, a);
              m = m.concat(u);
              h.each(u, function(a, c) {
                a.command = 0 >= c && d.command === e.Commands.move ? e.Commands.move : e.Commands.line;
              });
              p >= c &&
                (this._closed && this._automatic
                  ? ((d = r),
                    (u = n(r, d, a)),
                    (m = m.concat(u)),
                    h.each(u, function(a, c) {
                      a.command = 0 >= c && d.command === e.Commands.move ? e.Commands.move : e.Commands.line;
                    }))
                  : k && m.push(new e.Anchor(r.x, r.y)),
                (m[m.length - 1].command = k ? e.Commands.close : e.Commands.line));
            }
          d = r;
        },
        this,
      );
      this._curved = this._automatic = !1;
      this.vertices = m;
      return this;
    },
    _updateLength: function(a) {
      this._update();
      var c = this.vertices.length - 1,
        d = this.vertices[c],
        k = this._closed || this.vertices[c]._command === e.Commands.close,
        m = 0;
      h.isUndefined(this._lengths) && (this._lengths = []);
      h.each(
        this.vertices,
        function(h, n) {
          (0 >= n && !k) || h.command === e.Commands.move
            ? ((d = h), (this._lengths[n] = 0))
            : ((this._lengths[n] = p(h, d, a)),
              (m += this._lengths[n]),
              n >= c && k && ((d = h), (this._lengths[n + 1] = p(h, d, a)), (m += this._lengths[n + 1])),
              (d = h));
        },
        this,
      );
      this._length = m;
      return this;
    },
    _update: function() {
      if (this._flagVertices) {
        var a = this.vertices.length - 1,
          c;
        c = m(this._beginning * a);
        a = m(this._ending * a);
        this._vertices.length = 0;
        for (var d = c; d < a + 1; d++) (c = this.vertices[d]), this._vertices.push(c);
        this._automatic && this.plot();
      }
      e.Shape.prototype._update.apply(this, arguments);
      return this;
    },
    flagReset: function() {
      this._flagVertices = this._flagFill = this._flagStroke = this._flagLinewidth = this._flagOpacity = this._flagVisible = this._flagCap = this._flagJoin = this._flagMiter = this._flagClip = !1;
      e.Shape.prototype.flagReset.call(this);
      return this;
    },
  });
  c.MakeObservable(c.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = e.Path,
    n = (e.Line = function(h, k, m, a) {
      m = (m - h) / 2;
      a = (a - k) / 2;
      p.call(this, [new e.Anchor(-m, -a), new e.Anchor(m, a)]);
      this.translation.set(h + m, k + a);
    });
  h.extend(n.prototype, p.prototype);
  p.MakeObservable(n.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = e.Path,
    n = (e.Rectangle = function(h, k, m, a) {
      m /= 2;
      a /= 2;
      p.call(this, [new e.Anchor(-m, -a), new e.Anchor(m, -a), new e.Anchor(m, a), new e.Anchor(-m, a)], !0);
      this.translation.set(h, k);
    });
  h.extend(n.prototype, p.prototype);
  p.MakeObservable(n.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = e.Path,
    n = 2 * Math.PI,
    r = Math.cos,
    k = Math.sin,
    m = (e.Ellipse = function(a, c, f, l) {
      h.isNumber(l) || (l = f);
      var d = e.Resolution,
        m = h.map(
          h.range(d),
          function(a) {
            var c = (a / d) * n;
            a = f * r(c);
            c = l * k(c);
            return new e.Anchor(a, c);
          },
          this,
        );
      p.call(this, m, !0, !0);
      this.translation.set(a, c);
    });
  h.extend(m.prototype, p.prototype);
  p.MakeObservable(m.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = e.Path,
    n = 2 * Math.PI,
    r = Math.cos,
    k = Math.sin,
    m = (e.Polygon = function(a, c, f, l) {
      l = Math.max(l || 0, 3);
      var d = h.map(h.range(l), function(a) {
        var c = n * ((a + 0.5) / l) + Math.PI / 2;
        a = f * r(c);
        c = f * k(c);
        return new e.Anchor(a, c);
      });
      p.call(this, d, !0);
      this.translation.set(a, c);
    });
  h.extend(m.prototype, p.prototype);
  p.MakeObservable(m.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = e.Path,
    n = Math.PI,
    r = Math.PI / 2,
    k = Math.cos,
    m = Math.sin,
    a = (e.ArcSegment = function(a, f, h, d, t, s, D) {
      t > s && (s += 2 * Math.PI);
      D = D || 8;
      s -= t;
      var y = s / D,
        u = e.Commands.move,
        g = [];
      g.push(new e.Anchor(Math.sin(0) * d, Math.cos(0) * d, 0, 0, 0, 0, u));
      for (var j, x, w, v, z, E, u = e.Commands.curve, A = 0; A < D + 1; A++)
        (j = A * y),
          (x = m(j) * d),
          (w = k(j) * d),
          (v = m(j - r) * (y / n) * d),
          (z = k(j - r) * (y / n) * d),
          (E = m(j + r) * (y / n) * d),
          (j = k(j + r) * (y / n) * d),
          0 === A && (v = z = 0),
          A === D && (E = j = 0),
          g.push(new e.Anchor(x, w, v, z, E, j, u));
      for (A = 0; A < D + 1; A++)
        (j = s - y * A),
          (x = m(j) * h),
          (w = k(j) * h),
          (v = m(j - 1.5 * n) * (y / n) * h),
          (z = k(j - 1.5 * n) * (y / n) * h),
          (E = m(j + 1.5 * n) * (y / n) * h),
          (j = k(j + 1.5 * n) * (y / n) * h),
          0 === A && (v = z = 0),
          A === D && (E = j = 0),
          g.push(new e.Anchor(x, w, v, z, E, j, u));
      u = e.Commands.close;
      g.push(new e.Anchor(Math.sin(0) * d, Math.cos(0) * d, 0, 0, 0, 0, u));
      p.call(this, g, !0, !1, !0);
      this.rotation = t;
      this.translation.set(a, f);
    });
  h.extend(a.prototype, p.prototype);
  p.MakeObservable(a.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = e.Path,
    n = Math.PI,
    r = Math.cos,
    k = Math.sin,
    m = (e.SineRing = function(a, c, f, h, d, m) {
      var s = 2 * h + 1,
        D = Math.PI / h;
      h = (n * f) / h / 2;
      m = m || 1;
      var y = [],
        u = n,
        g,
        j,
        x,
        w,
        v;
      y.push(new e.Anchor(k(u) * (f + d / 2), r(u) * (f + d / 2), 0, 0, 0, 0, e.Commands.move));
      for (var z = 0; z < s; z++)
        (u = D * z + n),
          0 === z % 2
            ? ((g = Math.sin(u) * (f + d / 2)), (j = Math.cos(u) * (f + d / 2)))
            : ((g = Math.sin(u) * (f - d / 2)), (j = Math.cos(u) * (f - d / 2))),
          (x = Math.sin(u - Math.PI / 2) * h * m),
          (w = Math.cos(u - Math.PI / 2) * h * m),
          (v = Math.sin(u + Math.PI / 2) * h * m),
          (u = Math.cos(u + Math.PI / 2) * h * m),
          0 === z && (x = w = 0),
          z === s - 1 && (v = u = 0),
          y.push(new e.Anchor(g, j, x, w, v, u, e.Commands.curve));
      p.call(this, y, !0, !1, !0);
      this.translation.set(a, c);
    });
  h.extend(m.prototype, p.prototype);
  p.MakeObservable(m.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = e.Path,
    n = 2 * Math.PI,
    r = Math.cos,
    k = Math.sin,
    m = (e.Star = function(a, c, f, l, d) {
      h.isNumber(l) || (l = f / 2);
      if (!h.isNumber(d) || 0 >= d) d = 5;
      var m = 2 * d;
      d = h.map(h.range(m), function(a) {
        var c = ((a - 0.5) / m) * n,
          d = a % 2 ? l : f;
        a = d * r(c);
        c = d * k(c);
        return new e.Anchor(a, c);
      });
      p.call(this, d, !0);
      this.translation.set(a, c);
    });
  h.extend(m.prototype, p.prototype);
  p.MakeObservable(m.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  function p(k, m, a, c, f) {
    var l = 0,
      d = 0,
      n = e.Resolution;
    new e.Anchor(m, a);
    var r = 0 > m ? -c : c,
      p = 0 > a ? -c : c;
    switch (f) {
      case 1:
        l = -Math.PI / 2;
        d = 0;
        break;
      case 2:
        l = -Math.PI;
        d = -Math.PI / 2;
        break;
      case 3:
        l = 1.5 * -Math.PI;
        d = -Math.PI;
        break;
      case 4:
        (l = 0), (d = Math.PI / 2);
    }
    f = h
      .map(h.range(n), function(f) {
        var h = l + (d - l) * ((n - f - 0) / (n - 0));
        f = c * Math.cos(h) + m - r;
        h = c * Math.sin(h) + a - p;
        return new e.Anchor(f, h);
      })
      .reverse();
    return k.concat(f);
  }
  var n = e.Path,
    r = (e.RoundedRectangle = function(k, m, a, c, f) {
      var l = a / 2,
        d = c / 2;
      h.isNumber(f) || (f = Math.floor(Math.min(a, c) / 12));
      a = [new e.Anchor(-l + f, -d), new e.Anchor(l - f, -d)];
      a = p(a, l, -d, f, 1);
      a.push(new e.Anchor(l, d - f));
      a = p(a, l, d, f, 4);
      a.push(new e.Anchor(-l + f, d));
      a = p(a, -l, d, f, 3);
      a.push(new e.Anchor(-l, -d + f));
      a = p(a, -l, -d, f, 2);
      a.pop();
      n.call(this, a, !0);
      this.translation.set(k, m);
    });
  h.extend(r.prototype, n.prototype);
  n.MakeObservable(r.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = e.Utils.getComputedMatrix;
  document.createElement('canvas').getContext('2d');
  e.Text = function(n, r, k, m) {
    e.Shape.call(this);
    this._renderer.type = 'text';
    this.value = n;
    h.isNumber(r) && (this.translation.x = r);
    h.isNumber(k) && (this.translation.y = k);
    if (!h.isObject(m)) return this;
    h.each(
      e.Text.Properties,
      function(a) {
        a in m && (this[a] = m[a]);
      },
      this,
    );
  };
  h.extend(e.Text, {
    Properties: 'value family size leading alignment fill stroke linewidth style weight decoration baseline opacity visible'.split(
      ' ',
    ),
    MakeObservable: function(n) {
      e.Shape.MakeObservable(n);
      h.each(e.Text.Properties, function(e) {
        var h = '_' + e,
          m = '_flag' + e.charAt(0).toUpperCase() + e.slice(1);
        Object.defineProperty(n, e, {
          get: function() {
            return this[h];
          },
          set: function(a) {
            this[h] = a;
            this[m] = !0;
          },
        });
      });
      Object.defineProperty(n, 'clip', {
        get: function() {
          return this._clip;
        },
        set: function(e) {
          this._clip = e;
          this._flagClip = !0;
        },
      });
    },
  });
  h.extend(e.Text.prototype, e.Shape.prototype, {
    _flagValue: !0,
    _flagFamily: !0,
    _flagSize: !0,
    _flagLeading: !0,
    _flagAlignment: !0,
    _flagBaseline: !0,
    _flagStyle: !0,
    _flagWeight: !0,
    _flagDecoration: !0,
    _flagFill: !0,
    _flagStroke: !0,
    _flagLinewidth: !0,
    _flagOpacity: !0,
    _flagVisible: !0,
    _flagClip: !1,
    _value: '',
    _family: 'sans-serif',
    _size: 13,
    _leading: 17,
    _alignment: 'center',
    _baseline: 'middle',
    _style: 'normal',
    _weight: 500,
    _decoration: 'none',
    _fill: '#000',
    _stroke: 'transparent',
    _linewidth: 1,
    _opacity: 1,
    _visible: !0,
    _clip: !1,
    clone: function(n) {
      n = n || this.parent;
      var r = new e.Text(this.value);
      r.translation.copy(this.translation);
      r.rotation = this.rotation;
      r.scale = this.scale;
      h.each(
        e.Text.Properties,
        function(e) {
          r[e] = this[e];
        },
        this,
      );
      n.add(r);
      return r;
    },
    toObject: function() {
      var n = { translation: this.translation.toObject(), rotation: this.rotation, scale: this.scale };
      h.each(
        e.Text.Properties,
        function(e) {
          n[e] = this[e];
        },
        this,
      );
      return n;
    },
    noStroke: function() {
      this.stroke = 'transparent';
      return this;
    },
    noFill: function() {
      this.fill = 'transparent';
      return this;
    },
    getBoundingClientRect: function(e) {
      this._update(!0);
      e = (e ? this._matrix : p(this)).multiply(0, 0, 1);
      return { top: e.x, left: e.y, right: e.x, bottom: e.y, width: 0, height: 0 };
    },
    flagReset: function() {
      this._flagValue = this._flagFamily = this._flagSize = this._flagLeading = this._flagAlignment = this._flagFill = this._flagStroke = this._flagLinewidth = this._flagOpaicty = this._flagVisible = this._flagClip = this._flagDecoration = this._flagBaseline = !1;
      e.Shape.prototype.flagReset.call(this);
      return this;
    },
  });
  e.Text.MakeObservable(e.Text.prototype);
})(
  Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : _,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : requestAnimationFrame,
);
(function(e, h, p) {
  var n = (e.Stop = function(e, m, a) {
    this._renderer = {};
    this.offset = h.isNumber(e) ? e : 0 >= n.Index ? 0 : 1;
    this.opacity = h.isNumber(a) ? a : 1;
    this.color = h.isString(m) ? m : 0 >= n.Index ? '#fff' : '#000';
    n.Index = (n.Index + 1) % 2;
  });
  h.extend(n, {
    Index: 0,
    Properties: ['offset', 'opacity', 'color'],
    MakeObservable: function(k) {
      h.each(n.Properties, function(h) {
        var a = '_' + h,
          c = '_flag' + h.charAt(0).toUpperCase() + h.slice(1);
        Object.defineProperty(k, h, {
          get: function() {
            return this[a];
          },
          set: function(f) {
            this[a] = f;
            this[c] = !0;
            this.trigger(e.Events.change);
          },
        });
      });
    },
  });
  h.extend(n.prototype, p.Events, {
    clone: function() {
      var e = new n();
      h.each(
        n.Properties,
        function(h) {
          e[h] = this[h];
        },
        this,
      );
      return e;
    },
    toObject: function() {
      var e = {};
      h.each(
        n.Properties,
        function(h) {
          e[h] = this[h];
        },
        this,
      );
      return e;
    },
    flagReset: function() {
      this._flagOffset = this._flagColor = this._flagOpacity = !1;
      return this;
    },
  });
  n.MakeObservable(n.prototype);
  var r = (e.Gradient = function(h) {
    e.Shape.call(this);
    this._renderer.type = 'gradient';
    this.spread = 'pad';
    this.stops = h;
  });
  h.extend(r, {
    Stop: n,
    Properties: ['spread'],
    MakeObservable: function(k) {
      e.Shape.MakeObservable(k);
      h.each(r.Properties, e.Utils.defineProperty, k);
      Object.defineProperty(k, 'stops', {
        get: function() {
          return this._stops;
        },
        set: function(k) {
          var a = h.bind(r.FlagStops, this),
            c = h.bind(function(c) {
              for (var d = c.length; d--; ) c[d].bind(e.Events.change, a);
              a();
            }, this),
            f = h.bind(function(c) {
              h.each(
                c,
                function(c) {
                  c.unbind(e.Events.change, a);
                },
                this,
              );
              a();
            }, this);
          this._stops && this._stops.unbind();
          this._stops = new e.Utils.Collection((k || []).slice(0));
          this._stops.bind(e.Events.insert, c);
          this._stops.bind(e.Events.remove, f);
          c(this._stops);
        },
      });
    },
    FlagStops: function() {
      this._flagStops = !0;
    },
  });
  h.extend(r.prototype, e.Shape.prototype, {
    clone: function(k) {
      k = k || this.parent;
      var m = h.map(this.stops, function(a) {
          return a.clone();
        }),
        a = new r(m);
      h.each(
        e.Gradient.Properties,
        function(c) {
          a[c] = this[c];
        },
        this,
      );
      a.translation.copy(this.translation);
      a.rotation = this.rotation;
      a.scale = this.scale;
      k.add(a);
      return a;
    },
    toObject: function() {
      var e = {
        stops: h.map(this.stops, function(e) {
          return e.toObject();
        }),
      };
      h.each(
        r.Properties,
        function(h) {
          e[h] = this[h];
        },
        this,
      );
      return e;
    },
    flagReset: function() {
      this._flagSpread = this._flagStops = !1;
      e.Shape.prototype.flagReset.call(this);
      return this;
    },
  });
  r.MakeObservable(r.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = (e.LinearGradient = function(n, r, k, m, a) {
    e.Gradient.call(this, a);
    this._renderer.type = 'linear-gradient';
    a = h.bind(p.FlagEndPoints, this);
    this.left = new e.Vector().bind(e.Events.change, a);
    this.right = new e.Vector().bind(e.Events.change, a);
    h.isNumber(n) && (this.left.x = n);
    h.isNumber(r) && (this.left.y = r);
    h.isNumber(k) && (this.right.x = k);
    h.isNumber(m) && (this.right.y = m);
  });
  h.extend(p, {
    Stop: e.Gradient.Stop,
    MakeObservable: function(h) {
      e.Gradient.MakeObservable(h);
    },
    FlagEndPoints: function() {
      this._flagEndPoints = !0;
    },
  });
  h.extend(p.prototype, e.Gradient.prototype, {
    _flagEndPoints: !1,
    clone: function(n) {
      n = n || this.parent;
      var r = h.map(this.stops, function(e) {
          return e.clone();
        }),
        k = new p(this.left._x, this.left._y, this.right._x, this.right._y, r);
      h.each(
        e.Gradient.Properties,
        function(e) {
          k[e] = this[e];
        },
        this,
      );
      n.add(k);
      return k;
    },
    toObject: function() {
      var h = e.Gradient.prototype.toObject.call(this);
      h.left = this.left.toObject();
      h.right = this.right.toObject();
      return h;
    },
    flagReset: function() {
      this._flagEndPoints = !1;
      e.Gradient.prototype.flagReset.call(this);
      return this;
    },
  });
  p.MakeObservable(p.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  var p = (e.RadialGradient = function(n, p, k, m, a, c) {
    e.Gradient.call(this, m);
    this._renderer.type = 'radial-gradient';
    this.center = new e.Vector().bind(
      e.Events.change,
      h.bind(function() {
        this._flagCenter = !0;
      }, this),
    );
    this.radius = h.isNumber(k) ? k : 20;
    this.focal = new e.Vector().bind(
      e.Events.change,
      h.bind(function() {
        this._flagFocal = !0;
      }, this),
    );
    h.isNumber(n) && (this.center.x = n);
    h.isNumber(p) && (this.center.y = p);
    this.focal.copy(this.center);
    h.isNumber(a) && (this.focal.x = a);
    h.isNumber(c) && (this.focal.y = c);
  });
  h.extend(p, {
    Stop: e.Gradient.Stop,
    Properties: ['radius'],
    MakeObservable: function(n) {
      e.Gradient.MakeObservable(n);
      h.each(p.Properties, e.Utils.defineProperty, n);
    },
  });
  h.extend(p.prototype, e.Gradient.prototype, {
    _flagEndPoints: !1,
    clone: function(n) {
      n = n || this.parent;
      var r = h.map(this.stops, function(e) {
          return e.clone();
        }),
        k = new p(this.center._x, this.center._y, this._radius, r, this.focal._x, this.focal._y);
      h.each(
        e.Gradient.Properties.concat(p.Properties),
        function(e) {
          k[e] = this[e];
        },
        this,
      );
      n.add(k);
      return k;
    },
    toObject: function() {
      var n = e.Gradient.prototype.toObject.call(this);
      h.each(
        p.Properties,
        function(e) {
          n[e] = this[e];
        },
        this,
      );
      n.center = this.center.toObject();
      n.focal = this.focal.toObject();
      return n;
    },
    flagReset: function() {
      this._flagRadius = this._flagCenter = this._flagFocal = !1;
      e.Gradient.prototype.flagReset.call(this);
      return this;
    },
  });
  p.MakeObservable(p.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
(function(e, h) {
  function p(a, c) {
    var e = a.parent,
      l;
    e &&
      e.children.ids[a.id] &&
      ((l = h.indexOf(e.children, a)),
      e.children.splice(l, 1),
      (l = h.indexOf(e.additions, a)),
      0 <= l ? e.additions.splice(l, 1) : (e.subtractions.push(a), (e._flagSubtractions = !0)));
    c
      ? ((a.parent = c), this.additions.push(a), (this._flagAdditions = !0))
      : ((l = h.indexOf(this.additions, a)),
        0 <= l ? this.additions.splice(l, 1) : (this.subtractions.push(a), (this._flagSubtractions = !0)),
        delete a.parent);
  }
  var n = Math.min,
    r = Math.max,
    k = function() {
      e.Utils.Collection.apply(this, arguments);
      Object.defineProperty(this, '_events', { value: {}, enumerable: !1 });
      this.ids = {};
      this.on(e.Events.insert, this.attach);
      this.on(e.Events.remove, this.detach);
      k.prototype.attach.apply(this, arguments);
    };
  k.prototype = new e.Utils.Collection();
  k.constructor = k;
  h.extend(k.prototype, {
    attach: function(a) {
      for (var c = 0; c < a.length; c++) this.ids[a[c].id] = a[c];
      return this;
    },
    detach: function(a) {
      for (var c = 0; c < a.length; c++) delete this.ids[a[c].id];
      return this;
    },
  });
  var m = (e.Group = function() {
    e.Shape.call(this, !0);
    this._renderer.type = 'group';
    this.additions = [];
    this.subtractions = [];
    this._children = [];
    this.children = arguments;
  });
  h.extend(m, {
    Children: k,
    InsertChildren: function(a) {
      for (var c = 0; c < a.length; c++) p.call(this, a[c], this);
    },
    RemoveChildren: function(a) {
      for (var c = 0; c < a.length; c++) p.call(this, a[c]);
    },
    OrderChildren: function() {
      this._flagOrder = !0;
    },
    MakeObservable: function(a) {
      var c = e.Path.Properties.slice(0),
        f = h.indexOf(c, 'opacity');
      0 <= f &&
        (c.splice(f, 1),
        Object.defineProperty(a, 'opacity', {
          get: function() {
            return this._opacity;
          },
          set: function(a) {
            this._flagOpacity = this._opacity != a;
            this._opacity = a;
          },
        }));
      e.Shape.MakeObservable(a);
      m.MakeGetterSetters(a, c);
      Object.defineProperty(a, 'children', {
        get: function() {
          return this._collection;
        },
        set: function(a) {
          var c = h.bind(m.InsertChildren, this),
            f = h.bind(m.RemoveChildren, this),
            n = h.bind(m.OrderChildren, this);
          this._collection && this._collection.unbind();
          this._collection = new k(a);
          this._collection.bind(e.Events.insert, c);
          this._collection.bind(e.Events.remove, f);
          this._collection.bind(e.Events.order, n);
        },
      });
      Object.defineProperty(a, 'mask', {
        get: function() {
          return this._mask;
        },
        set: function(a) {
          this._mask = a;
          this._flagMask = !0;
          a.clip || (a.clip = !0);
        },
      });
    },
    MakeGetterSetters: function(a, c) {
      h.isArray(c) || (c = [c]);
      h.each(c, function(c) {
        m.MakeGetterSetter(a, c);
      });
    },
    MakeGetterSetter: function(a, c) {
      var e = '_' + c;
      Object.defineProperty(a, c, {
        get: function() {
          return this[e];
        },
        set: function(a) {
          this[e] = a;
          h.each(this.children, function(d) {
            d[c] = a;
          });
        },
      });
    },
  });
  h.extend(m.prototype, e.Shape.prototype, {
    _flagAdditions: !1,
    _flagSubtractions: !1,
    _flagOrder: !1,
    _flagOpacity: !0,
    _flagMask: !1,
    _fill: '#fff',
    _stroke: '#000',
    _linewidth: 1,
    _opacity: 1,
    _visible: !0,
    _cap: 'round',
    _join: 'round',
    _miter: 4,
    _closed: !0,
    _curved: !1,
    _automatic: !0,
    _beginning: 0,
    _ending: 1,
    _mask: null,
    clone: function(a) {
      a = a || this.parent;
      var c = new m();
      a.add(c);
      h.map(this.children, function(a) {
        return a.clone(c);
      });
      c.translation.copy(this.translation);
      c.rotation = this.rotation;
      c.scale = this.scale;
      return c;
    },
    toObject: function() {
      var a = { children: {}, translation: this.translation.toObject(), rotation: this.rotation, scale: this.scale };
      h.each(
        this.children,
        function(c, e) {
          a.children[e] = c.toObject();
        },
        this,
      );
      return a;
    },
    corner: function() {
      var a = this.getBoundingClientRect(!0),
        c = { x: a.left, y: a.top };
      this.children.forEach(function(a) {
        a.translation.subSelf(c);
      });
      return this;
    },
    center: function() {
      var a = this.getBoundingClientRect(!0);
      a.centroid = { x: a.left + a.width / 2, y: a.top + a.height / 2 };
      this.children.forEach(function(c) {
        c.translation.subSelf(a.centroid);
      });
      return this;
    },
    getById: function(a) {
      var c = function(a, e) {
        if (a.id === e) return a;
        if (a.children)
          for (var d = a.children.length; d--; ) {
            var h = c(a.children[d], e);
            if (h) return h;
          }
      };
      return c(this, a) || null;
    },
    getByClassName: function(a) {
      var c = [],
        e = function(a, d) {
          -1 != a.classList.indexOf(d)
            ? c.push(a)
            : a.children &&
              a.children.forEach(function(a) {
                e(a, d);
              });
          return c;
        };
      return e(this, a);
    },
    getByType: function(a) {
      var c = [],
        f = function(a, d) {
          for (var h in a.children)
            a.children[h] instanceof d
              ? c.push(a.children[h])
              : a.children[h] instanceof e.Group && f(a.children[h], d);
          return c;
        };
      return f(this, a);
    },
    add: function(a) {
      a = a instanceof Array ? a.slice() : h.toArray(arguments);
      for (var c = 0; c < a.length; c++) a[c] && a[c].id && this.children.push(a[c]);
      return this;
    },
    remove: function(a) {
      var c = this.parent;
      if (0 >= arguments.length && c) return c.remove(this), this;
      a = a instanceof Array ? a.slice() : h.toArray(arguments);
      for (c = 0; c < a.length; c++)
        a[c] && this.children.ids[a[c].id] && this.children.splice(h.indexOf(this.children, a[c]), 1);
      return this;
    },
    getBoundingClientRect: function(a) {
      var c;
      this._update(!0);
      var e = Infinity,
        k = -Infinity,
        d = Infinity,
        m = -Infinity;
      this.children.forEach(function(p) {
        /(linear-gradient|radial-gradient|gradient)/.test(p._renderer.type) ||
          ((c = p.getBoundingClientRect(a)),
          h.isNumber(c.top) &&
            (h.isNumber(c.left) && h.isNumber(c.right) && h.isNumber(c.bottom)) &&
            ((d = n(c.top, d)), (e = n(c.left, e)), (k = r(c.right, k)), (m = r(c.bottom, m))));
      }, this);
      return { top: d, left: e, right: k, bottom: m, width: k - e, height: m - d };
    },
    noFill: function() {
      this.children.forEach(function(a) {
        a.noFill();
      });
      return this;
    },
    noStroke: function() {
      this.children.forEach(function(a) {
        a.noStroke();
      });
      return this;
    },
    subdivide: function() {
      var a = arguments;
      this.children.forEach(function(c) {
        c.subdivide.apply(c, a);
      });
      return this;
    },
    flagReset: function() {
      this._flagAdditions && ((this.additions.length = 0), (this._flagAdditions = !1));
      this._flagSubtractions && ((this.subtractions.length = 0), (this._flagSubtractions = !1));
      this._flagOrder = this._flagMask = this._flagOpacity = !1;
      e.Shape.prototype.flagReset.call(this);
      return this;
    },
  });
  m.MakeObservable(m.prototype);
})(
  this.Two,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('underscore') : this._,
  'function' === typeof require && !('function' === typeof define && define.amd) ? require('backbone') : this.Backbone,
  'function' === typeof require && !('function' === typeof define && define.amd)
    ? require('requestAnimationFrame')
    : this.requestAnimationFrame,
);
